import { baseUrl } from './debugUrl'
//导入其他url
import HmqrAscoreUrl from './urls/hmqrAscoreUrl'
import InventoryList from "@/api/urls/inventory-list";
import Notices from "@/api/urls/notices";
import IndexUrl from "@/api/urls/IndexUrl";

import Decision from "@/api/urls/decision";
import Downloads from "@/api/urls/downloads";

const apiUrl = baseUrl + '/api'
const loginUrl = apiUrl + '/login'
const userUrl = apiUrl + '/users'
const carUrl = apiUrl + '/add'
const authorityUrl = apiUrl + '/authority'



/***************基础数据管理模块*********************** */
const basicdataqueryUrl = apiUrl + '/basicdataquery' // 路产查询相关
const basicDataAddUrl = apiUrl + '/basicdataadd' // 路产新增相关
const tsaFacilitiesQueryUrl = apiUrl + '/tsaFacilitiesQuery' //交安设施查询相关
const tsaFacilitiesAddUrl = apiUrl + '/TsaFacilitiesAdd' //交安设施操作相关
const diclistQueryUrl = apiUrl + '/diclist' //桥隧涵字典获取
const bridgequeryUrl = apiUrl + '/bridgequery' //桥梁相关
const bridgeAddUrl = apiUrl + '/bridgeadd' //桥梁操作
const tunnelQueryUrl = apiUrl + '/TunnelQuery' //隧道查询
const tunnelAddUrl = apiUrl + '/TunnelAdd' //隧道操作
const culvertqueryUrl = apiUrl + '/culvertquery' //涵洞查询
const culvertaddUrl = apiUrl + '/culvertadd' //涵洞操作
const mechanicalQueryUrl = apiUrl + '/MechanicalQuery' //机械设备查询
const mechanicalAddUrl = apiUrl + '/MechanicalAdd' //机械设备操作
const storagequeryUrl = apiUrl + '/storagequery' //养护材料查询
const storageaddUrl = apiUrl + '/storageadd' //养护材料操作
const emergencyqueryUrl = apiUrl + '/emergencyrescuequery' //应急抢险获取
const emergencyoperationUrl = apiUrl + '/emergencyrescueoperation' //应急抢险操作
const specialMaintenanceUrl = apiUrl + '/specialmaintenancequery' //维修专项查询
const specialmaintenanceoperationUrl = apiUrl + '/specialmaintenanceoperation' //维修专项操作
const btreinforceUrl = apiUrl + '/btreinforcequery' //桥隧维修加固查询
const btreinforceoperationUrl = apiUrl + '/btreinforceoperation' //桥隧维修加固操作
const lwjgreformUrl = apiUrl + '/lwjgreformquery' //路网结构改造查询
const lwjgreformoperationUrl = apiUrl + '/lwjgreformoperation' //路网结构改造操作
const bridgetunneldataqueryUrl = apiUrl + '/bridgetunneldataquery' //桥隧涵检查数据查询
const bridgeTunnelOperationUrl = apiUrl + '/BridgeTunnelOperation' //桥隧涵检查数据操作
const humanresourcesUrl = apiUrl + '/humanresources' //人事管理
const maintenancefileUrl = apiUrl + '/maintenancefile' //养护维修档案
const roadnetqueryUrl = apiUrl + '/roadnetworkremouldquery' //路网改造获取
const roadnetoperationUrl = apiUrl + '/roadnetworkremouldoperation' //路网改造操作
const cellDivisionUrl = apiUrl + '/cellDivision'
const noticeUrl = apiUrl + '/notice' //通知管理
const bridgetunneloperationUrl = apiUrl + '/bridgetunneloperation' //桥梁经检复制

//const workflowadd = apiUrl + '/workflowadd' //操作清单计量类项目


/***************养护数据管理模块*********************** */
/*********日常养护管理模块********* */
const androidUrl = apiUrl + '/android' //安卓接口
const workflowqueryUrl = apiUrl + '/workflowquery' // 定量查询
const workflowaddUrl = apiUrl + '/workflowadd' //定量操作
const everydayqueryUrl = apiUrl + '/everydayquery' // 普通干线查询
const everydayaddUrl = apiUrl + '/everydayadd' //普通干线操作
const qualitativequeryUrl = apiUrl + '/qualitativequery' // 定量查询
const qualitativeaddUrl = apiUrl + '/qualitativeadd' //定量操作

const downloads = new Downloads(baseUrl)

let url
url = {
    qrCodeUrl: "http://117.157.231.103",
    // qrCodeUrl: "https://zhyh.gsgl.org.cn",
    getindexqainfolist: apiUrl + "/authority/getindexqainfolist", //获取首页数据
    /*404*/
    $404: apiUrl + '/404',
    /***
     * 上传文件
     */
    uploadfiles: apiUrl + '/importoperation/uploadfiles',
    importsysrole: apiUrl + '/importoperation/importsysrole', //角色导入
    uploadapk: apiUrl + '/importoperation/uploadapk', //app文件上传
    /**
     * 模板下载
     */
    // downLoadFile:apiUrl + '/exportfile/exportdownload',
    downLoadFile: apiUrl + '/filesDownload/exportdownload',
    uploadimages: apiUrl + '/importoperation/uploadimages',
    index_getinspections: apiUrl + '/analysis/getinspectionsnew', //首页获取巡查
    /***
     * 文件导出
     */
    downLoad: {
        exportMqiNationalAssessTable: apiUrl + '/assessimport/exporttunnelevaluationreport',//路面技术评定-----国检评定表导出
        exportAsphaltDisease: apiUrl + '',//路面病害----沥青路面病害
        exprotMqiRoadTrip: apiUrl + '',//其他路面信息-----路面跳车
        exportMqiSurfaceEvenness: apiUrl + '',//其他路面信息----路面平整度
        exportMqiPavementRut: apiUrl + '',//其他路面信息----路面车辙
        exportMqiRoadSkidResistance: apiUrl + '',//其他路面信息----路面抗滑

        exportroutesfile: apiUrl + "/exportfile/exportroutesfile", //路线
        roadSectionDownLoad: apiUrl + "/exportfile/exportroutesectionsfile", //路段
        bdRoadNetworkDownLoad: apiUrl + "/exportfile/exportroadnetworksfile", //路网

        bdStructureTemplateDownLoad: apiUrl + "/exportfile/exportstructuretemplatefile", //结构库
        bdStructureMaterialDownLoad: apiUrl + "/exportfile/exportmaterialfile", //材料库
        bdRouteStructureDownLoad: apiUrl + "/exportfile/exportroutestructurefile", //路面结构信息

        bdSideSlopeDownLoad: apiUrl + "/exportfile/exportsideslopefile", //路基边坡
        bdDrainageFacilityDownLoad: apiUrl + "/exportfile/exportdrainagefacilityfile", //路基排水设施

        bdAntiglareBoardTable: apiUrl + "/exportfile/exportantiglareboardsfile", //防眩板
        bdAntiglareNetTable: apiUrl + '/exportfile/exportantiglarenetsfile', //防眩网
        bdAttachedMarkTable: apiUrl + "/exportfile/exportattachedmarksfile", //附着式轮廓标
        bdBridgeProtectNetTable: apiUrl + "/exportfile/exportbridgeprotectnetsfile", //桥梁防护网
        bdGuardBarTable: apiUrl + "/exportfile/exportguardbarsfile", //护栏
        bdHundredBrandTable: apiUrl + "/exportfile/exporthundredbrandsfile", //百米牌
        bdInformationBoardTable: apiUrl + "/exportfile/exportinformationboardsfile", //可变情报板
        bdIsolatedGridTable: apiUrl + "/exportfile/exportisolatedgridsfile", //隔离栅
        bdMovableRailTable: apiUrl + "/exportfile/exportmovablerailsfile", //活动护栏
        bdPillarMarkTable: apiUrl + "/exportfile/exportpillarmarksfile", //柱式轮廓标
        bdSignBoardTable: apiUrl + "/exportfile/exportsignboardsfile", //标志牌
        bdSignLineTable: apiUrl + "/exportfile/exportsignlinesfile", //标线

        bdMaintainMaterialDownLoad: apiUrl + "/exportfile/exportmaintainmaterialsfile", //养护材料管理
        bdMaterialEnterStockInDownLoad: apiUrl + "", //养护材料入库导出
        bdMaterialEnterStockPutDownLoad: apiUrl + "", //养护材料出库

        bdDeviceRepairRecordDownLoad: apiUrl + "", //⚪
        bdDeviceDownLoad: apiUrl + "", //机械设备基础信息⚪
        bdDeviceUseRecordDownLoad: apiUrl + "", //机械设备使用记录⚪
        bdDevicejx: apiUrl + "/exportfile/exportjixie", //机械设备基础信息
        bdDevicecl: apiUrl + "/exportfile/exportcheliang", //机械设备基础信息
        bdDevicezip: apiUrl + "/exportfile/exportnewdevicezip",//

        bdInterchangeDownLoad: apiUrl + "/exportfile/exportinterchangefile", //立体交叉管理
        bdMaterialFieldDownLoad: apiUrl + "/exportfile/exportmaterialfieldfile", //料场表
        bdMixingStationDownLoad: apiUrl + "/exportfile/exportmixingstationfile", //拌合站表
        bdStorehouseDownLoad: apiUrl + "/exportfile/exportstorehousefile", //仓库管理
        bdTollStationDownLoad: apiUrl + "/exportfile/exporttollstationfile", //收费站表
        bdTrafficFlowStationDownLoad: apiUrl + "/exportfile/exporttrafficflowstationfile", //交通量调查站表
        bdAtubeStation: apiUrl + '/exportfile/exportatubestationfile', //养管站

        bridgeDownLoad: apiUrl + "/exportfile/exportbridgefile", //桥梁数据
        culvertDownLoad: apiUrl + "/exportfile/exportculvertfile", //涵洞数据
        tunnelDownLoad: apiUrl + "/exportfile/exporttunnelfile", //隧道数据

        jobPlanMasterEDownLoad: apiUrl + "/exportfile/exporteverydayjobplanfile", //每日-月计划
        inspectionRecordEDownLoad: apiUrl + "/exportfile/exporetinspectionrecordfilezip", //每日-巡查记录
        newexportinspectionrecordfiles: apiUrl + '/exportfile/newexportinspectionrecordfile', //每日-新巡查记录导出(普干)
        diseaseSetEDownLoad: apiUrl + "", //每日-病害登记⚪
        minorReportEDownLoad: apiUrl + "/exportfile/exporteminorlistfilezip", //每日-小修通报
        safetyFacilityLayEDownLoad: apiUrl + "/exportfile/exportesafetyfacilitylayfilezip", //每日-安全布设
        maintainOREDownLoad: apiUrl + "/exportfile/exportmaintainfilesnew", //每日-维修记录exportemaintainfilezip
        acceptanceApplyEDownLoad: apiUrl + "", //每日-验收提交⚪
        rectificationOrderEDownLoad: apiUrl + "/exportfile/exporterectificationorderfilezip", //每日-整改通知

        maintainORQDownLoad: apiUrl + "", //定性-维修记录⚪
        safetyFacilityLayQDownLoad: apiUrl + "", //定性-安全布设⚪
        jobPlanMasterQTable: apiUrl + "", //定性-月作业计划⚪
        rectificationOrderQDownLoad: apiUrl + "", //定性-整改通知⚪

        exportjobplanmasterfile: apiUrl + "/exportfile/exportjobplanmasterfile", //月报表
        inspectionRecordDownLoad: apiUrl + "/exportfile/exportinspectionrecordfilezip", //定量-巡查记录
        diseaseSetDownLoad: apiUrl + "", //定量-病害登记⚪
        minorReportDownLoad: apiUrl + "/exportfile/exportminorlistfilezip", //定量-小修通报
        safetyFacilityLayDownLoad: apiUrl + "/exportfile/exportsafetyfacilitylayfilezip", //定量-安全布设
        maintainORDownLoad: apiUrl + "/exportfile/exportdlmaintainfilesnew", //定量-维修记录exportmaintainfilezip
        acceptanceApplyDownLoad: apiUrl + "", //定量-验收申请⚪
        rectificationOrderDownLoad: apiUrl + "/exportfile/exportrectificationorderfilezip", //定量-整改通知
        exportdlinspectionrecordfiles: apiUrl + '/exportfile/exportdlinspectionrecordfile', //定量-新巡查记录导出

        exportconstructionunitsfile: apiUrl + '/exportfile/exportconstructionunitsfile', //养护单位-施工单位信息
        exportcreditratingsfile: apiUrl + '/exportfile/exportcreditratingsfile', //养护单位-单位信用评价
        exportreportsfile: apiUrl + '/exportfile/exportreportsfile', //水毁情况-水毁上报
        exportlossrepairsumsfile: apiUrl + '/exportfile/exportlossrepairsumsfile', //养护工程-损失和抢通情况
        exportreconstructionplanfile: apiUrl + '/exportfile/exportreconstructionplanfile', //养护工程-恢复重建

        erEmergenceDuty: apiUrl + "", //应急值班管理
        erEmergenceNews: apiUrl + "", //新闻发布
        erEmergenceNotice: +"", //通知发布
        erEmergencePhone: +"", //应急电话管理
        erEmergencePlan: +"", //应急预案管理
        erEmergencyReport: +"", //应急事件报送
        erExpress: +"", //应急信息每日快报
        erExpressSet: +"", //每日快报设置
        erExpressSum: +"", //应急信息每日快报
        erRequestResource: +"", //应急物资征用
        erResponseFeedback: +"", //应急响应反馈
        erWarningFeedback: +"", //预警信息反馈

        wxzxAcceptApply: +"", //交工验收申请
        wxzxCaCertificate: +"", //维修工程竣工验收鉴定书
        wxzxCmceTable: +"", //施工管理综合评价表
        wxzxComplatedCe: +"", //竣工验收项目综合评定表
        wxzxCompletedQe: +"", //竣工验收工程质量评价表
        wxzxCompletedQg: +"", //竣工验收委员会工程质量评分表
        wxzxDelyworkAcceptCon: +"", //维修工程交工验收报告
        wxzxDesignChange: +"", //设计变更
        wxzxDesignWorkCe: +"", //设计工作综合评价表
        wxzxImEvaluate: +"", //管理综合评价表
        wxzxListingPayment: apiUrl + "/exportfile/exportlistingpaymentfile", //清单期中支付
        wxzxMaintainProDesign: apiUrl + "/exportfile/exportmaintainprodesignsfile", //维修工程设计
        wxzxProApplyCertificat: +"", //维修工程交工验收证书
        wxzxProQsAfterEvaluate: apiUrl + "/exportfile/exportproqsafterevaluatefile", //工程质量后评价
        wxzxQualityJobUnit: apiUrl + "/exportfile/exportqualityjobunitfile", //质量责任卡承包单位
        wxzxQualityScore: +"", //交工验收工程质量评分
        wxzxReportMaintainPlan: apiUrl + "/exportfile/exportreportmaintainplanfile", //维修计划上报
        wxzxSuperviseCe: +"", //监理工作综合评价表

        hrBasicInfo: apiUrl + "/ExportFile/exporthrbasicinformationsfile", //人事数据
        jsAmapDataDownLoad: apiUrl + '/exportfile/exportjsamapdatasfile', //云采数据导出
        exportmonthlyreport: apiUrl + '/exportfile/exportmonthlyreport', //维修月报表导出
        downlod_bridgerunningcheck: apiUrl + '/exportfile/donwload_bridfe_running_check', //桥梁经常检查

        exportmaintacceptrecordfile: apiUrl + '/exportfile/exportmaintacceptrecordfile', //验收记录

        tunnelFacilityFault: apiUrl + "/exportfile/", //隧道机电设施故障⚪
        tunnelRegularCheck: apiUrl + "/exportfile/", //隧道定期检查记录⚪
        tunnelRunningCheck: apiUrl + "/exportfile/", //隧道经常检查记录⚪
        tunnelSpecialCheck: apiUrl + "/exportfile/", //隧道特殊检查记录⚪

        efmBridgeMaintenanceFile: apiUrl + "/exportfile/exportqlwxfile", //桥梁维修档案⚪
        efmFacilityMaintenanceFile: apiUrl + "/exportfile/exportsswxfile", //设施维修档案⚪
        efmOilRepairFile: apiUrl + "/exportfile/exportylxbfile", //油路修补档案⚪
        efmRcRepairFile: apiUrl + "/exportfile/exportlmlffile", //路面裂缝修补档案⚪
        exporttunnelevaluationreport: apiUrl + '/assessimport/exporttunnelevaluationreport', //隧道评定报告导出
        exportbridgeevaluationreport: apiUrl + '/assessimport/exportbridgeevaluationreport', //桥梁评定导出
        exportrouteevaluationreport: apiUrl + '/assessimport/exportrouteevaluationreport' //路线评定导出
    },
    /**
     * 文件导入
     */
    importFiles: {
        importMqiNationalAssessTable: apiUrl + '/assessimport/nationalassess',//路面技术评定-----国检评定表
        importAsphaltDisease: apiUrl + '/assessimport/importasphaltbreakage',//路面病害----沥青路面病害 importrutting
        importMqiRoadTrip: apiUrl + '/assessimport/importtrip',//其他路面信息-----路面跳车
        importMqiSurfaceEvenness: apiUrl + '/assessimport/importsurfaceevenness',//其他路面信息----路面平整度
        importMqiPavementRut: apiUrl + '/assessimport/importrutting',//其他路面信息----路面车辙
        importMqiRoadSkidResistance: apiUrl + '/assessimport/importantiskating',//其他路面信息----路面抗滑

        importUser: apiUrl + '/importoperation/importuser', //用户管理导入
        routeTable: apiUrl + "/ImportOperation/importroute", //路线导入
        roadSectionTable: apiUrl + '/importoperation/importroutesection', //路段导入
        bdSideSlopeTable: apiUrl + '/importoperation/importsideslope', //路基边坡
        bdDrainageFacilityTable: apiUrl + '/importoperation/importdrainagefacility', //路基排水
        bdStructureTemplateTable: apiUrl + "/importoperation/importstructure", //结构库
        bdRouteStructureTable: apiUrl + '/importoperation/importroutestructure', //路面结构
        bdStructureMaterialTable: apiUrl + "/importoperation/importstructurematerial", //材料库
        hrBasicInfo: apiUrl + "/importoperation/importhrbasicinfo", //人事数据
        bdDeviceTable: apiUrl + '/importoperation/importdevice', //机械设备导入
        bdDevicejx: apiUrl + '/importoperation/importjixie', //机械设备导入
        bdDevicecl: apiUrl + '/importoperation/importcheliang', //机械设备导入
        bdDeviceUseRecordTable: apiUrl + '/importoperation/importdeviceuserecord', //机械设备使用记录导入
        bdDeviceRepairRecordTable: apiUrl + '/importoperation/importdevicerepairrecord', //机械设备保养记录导
        bdRoadNetworkTable: apiUrl + "/importoperation/importroadnetwork", //路网
        bridgeTable: apiUrl + "/importoperation/importbridge", //桥梁
        importbridge2: apiUrl + "/importoperation/importbridge2", //国家桥梁导入
        importbridgecomponents: apiUrl + "/importoperation/importbridgecomponents", //部件导入
        tunnelTable: apiUrl + "/importoperation/importtunnel", //隧道
        culvertTable: apiUrl + "/importoperation/importculvert", //涵洞
        bdAntiglareBoardTable: apiUrl + "/importoperation/importantiglareboard", //防眩板
        bdAntiglareNetTable: apiUrl + "/importoperation/importantiglarenet", //防眩网
        bdAttachedMarkTable: apiUrl + "/importoperation/importattachedmark", //附着式轮廓标
        bdBridgeProtectNetTable: apiUrl + "/importoperation/importbridgeprotectnet", //桥梁护网
        bdGuardBarTable: apiUrl + "/importoperation/importguardbar", //护栏
        bdHundredBrandTable: apiUrl + "/importoperation/importhundredbrand", //百米牌
        bdInformationBoardTable: apiUrl + "/importoperation/importinformationboard", //可变情报板
        bdIsolatedGridTable: apiUrl + "/importoperation/importisolatedgrid", //隔离栅
        bdMovableRailTable: apiUrl + "/importoperation/importmovablerail", //活动护栏
        bdPillarMarkTable: apiUrl + "/importoperation/importpillarmark", //柱式轮廓标
        bdSignBoardTable: apiUrl + "/importoperation/importsignboard", //标志牌
        bdSignLineTable: apiUrl + "/importoperation/importsignline", //标线
        bdMaintainMaterialTable: apiUrl + "/importoperation/importmaintainmaterial", //养护材料管理
        bdMaterialEnterStockInTable: apiUrl + "/importoperation/importmaterialenterstockin", //养护材料入库
        bdMaterialEnterStockPutTable: apiUrl + "/importoperation/importmaterialenterstockout", //养护材料出库
        imporinspectionW: apiUrl + '/workflowadd/imporinspection', //定量-巡查导入
        imporinspectionE: apiUrl + "/everydayadd/imporinspection", //普通干线-巡查导入
        bdInterchangeTable: apiUrl + '/importoperation/importinterchange', //立体交叉导入
        bdMaterialFieldTable: apiUrl + '/importoperation/importmaterialfield', //料场导入
        bdMixingStationTable: apiUrl + '/importoperation/importmixingstation', //拌合站
        bdStorehouseTable: apiUrl + '/importoperation/importwarehouse', //仓库
        bdTollStationTable: apiUrl + '/importoperation/importtollstation', //收费站
        bdTrafficFlowStation: apiUrl + "/importoperation/importtrafficflowstation", //交通调查站
        bdAtubeStation: apiUrl + '/importoperation/importatubestation', //养管站
        importmuconstructionunit: apiUrl + '/importoperation/importmuconstructionunit', //施工单位基本信息
        importhrbasicinfo: apiUrl + "/importoperation/importhrbasicinfo", //人事基本信息

        bridgeRegularCheck: apiUrl + '/importoperation/', //桥梁定期检查记录⚪
        bridgeRunningCheck: apiUrl + '/importoperation/', //桥梁经常检查记录⚪
        bridgeSpecialCheck: apiUrl + '/importoperation/', //桥梁特殊检查记录⚪
        culvertRegularCheck: apiUrl + '/importoperation/', //涵洞定期检查记录⚪
        culvertRunningCheck: apiUrl + '/importoperation/', //涵洞经常检查记录⚪
        tunnelFacilityFault: apiUrl + '/importoperation/', //隧道机电设施故障⚪
        tunnelRegularCheck: apiUrl + "/importoperation/", //隧道定期检查记录⚪
        tunnelRunningCheck: apiUrl + "/importoperation/", //隧道经常检查记录⚪
        tunnelSpecialCheck: apiUrl + "/importoperation/", //隧道特殊检查记录⚪
    },
    /**
     * 用户相关
     */
    user: {
        add: userUrl + '/add',
        login: loginUrl + '/userlogin',
        testccc: loginUrl + '/testccc',
        getpcmenu: loginUrl + '/getpcmenu', //请求按钮权限
        loginout: loginUrl + '/loginout',//退出登录
    },
    getCode: loginUrl + '/getcode',
    getToken: loginUrl + '/gettoken',
    getverify: loginUrl + '/getverify', //获取验证码
    gettopmenus: loginUrl + '/gettopmenus', //获取头部菜单栏
    getHeadMenu: loginUrl + '/getauthmenunew', //获取侧边菜单栏
    deleteimages: apiUrl + '/importoperation/deleteimages', //图片删除
    /**
     * 测试treeTable
     */
    getlist: loginUrl + '/getlist',
    /**
     * 角色权限相关
     */
    authority: {
        updatepassword: apiUrl + '/authority/updatepassword', //修改密码
        getdivisions: apiUrl + '/authority/getdivisions', //获取行政区域
        getroles: authorityUrl + '/getroles',
        resetpwd: authorityUrl + '/resps',
        getroletree: authorityUrl + '/getroletree',
        getOrgTree: authorityUrl + '/gettreenew', //获取组织机构树形
        gettreelist: authorityUrl + '/gettreelist', //获取组织机构树形(新)
        getownerlist: authorityUrl + '/getownerlist', //获取业主(项目库)
        getorganizes: authorityUrl + "/getorganizes",
        operationrole: authorityUrl + '/operationrole',
        getOrgList: authorityUrl + '/GetOrgTree', //获取组织机构列表
        operationorganize: authorityUrl + '/operationorganize',
        getadministrativetree: authorityUrl + '/getadministrativetree', //获取区域
        operationpermission: authorityUrl + '/operationpermission', //权限修改接口
        getpermissionnewtree: authorityUrl + '/getpermissionnewtree', //获取权限表单列表接口
        getpermission: authorityUrl + '/getpermission', //获取权限单例
        getztree: authorityUrl + '/getztree', //获取角色
        authorize: authorityUrl + '/authorize', //给角色授权
        getusers: authorityUrl + '/getusers', //用户列表接口
        operationuser: authorityUrl + '/operationuser', //用户操作接口
        getuser: authorityUrl + '/getuser', //用户单例查询
        getEventUser: authorityUrl + '/getdepartmentusers', //使用安全员

        getandroidversion: authorityUrl + "/getandroidversion", //app版本信息获取
        createappversion: authorityUrl + "/createappversion", //app版本控制新增
        operationdailyworkcontentdic: apiUrl + '/diclist/operationdailyworkcontentdic', //操作日常养护工作内容字典
        getdailyworkcontentdic: apiUrl + '/diclist/getdailyworkcontentdic', //日常养护工作内容字典列表条件查询
        getdailyworkcontentdictree: apiUrl + '/diclist/getdailyworkcontentdictree', //操作日常养护工作内容字典
    },
    /**
     * 构造物评定参数
     */
    mqiSParameter: {
        getsparameters: apiUrl + "/trafficassess/getsparameters", //主表列表
        operationsparameter: apiUrl + "/trafficassess/operationsparameter", //主表操作(sParameter)
        getsparametersublist: apiUrl + "/trafficassess/getsparametersublist", //子表列表
        operationsparametersublist: apiUrl + "/trafficassess/operationsparametersublist", //子表操作(sParameter)
        getbridgeassesses: apiUrl + "/trafficassess/getbridgeassesses", //桥梁评定获取
        operationbridgeassess: apiUrl + "/trafficassess/operationbridgeassess", //桥梁评定获取(bridgeAssess)
        bridgemodelrevise: apiUrl + '/modellibrary/bridgemodelrevise', //桥梁模型校验
        gettunnelassesses: apiUrl + "/trafficassess/gettunnelassesses", //隧道评定获取
        operationtunnelassess: apiUrl + "/trafficassess/operationtunnelassess", //隧道评定获取(tunnelAssess)
        tunnelmodelreviseasync: apiUrl + '/modellibrary/tunnelmodelreviseasync' //隧道校验
    },
    /**
     * 通知发布
     */
    noticeIssued: {
        getnotice: noticeUrl + "/getnotice", //获取表格
        operationnotice: noticeUrl + "/operationnotice", //操作(notice)

        getcarousel: noticeUrl + "/getcarousel", //获取轮播列表
        createcarousel: noticeUrl + "/createcarousel", //新增轮播(carousel)
        updatecarousel: noticeUrl + "/updatecarousel", //更新轮播
        deletecarousel: noticeUrl + "/deletecarousel", //删除轮播

        getfeedback: noticeUrl + "/getfeedback", //获取意见反馈
        createfeedback: noticeUrl + "/createfeedback", //新增意见反馈(feedBack)
        updatefeedback: noticeUrl + "/updatefeedback", //更新意见反馈
        deletefeedback: noticeUrl + "/deletefeedback", //删除意见反馈
    },
    /**
     * 字典获取
     */
    getitemsdetails: authorityUrl + '/getitemsdetails', //数据字典获取
    getsysitemtree: authorityUrl + '/getsysitemtree', //获取数据字典树形数据
    operationdetail: authorityUrl + '/operationdetail', //操作数据字典
    getitem: authorityUrl + '/getitem', //获取数据字典表格数据
    operationsysitem: authorityUrl + '/operationsysitem', //操作数据字典(子)
    getDict: basicdataqueryUrl + '/getditi',
    getOperation: diclistQueryUrl + '/getdiseasenameitemlist', //病害、作业项目字典
    operationdiseasenameitem: apiUrl + '/authority/operationdiseasenameitem', //病害、作业项目字典操作
    getminorprojectlist: workflowqueryUrl + '/getminorprojectlist', //获取项目库表格
    getsafetyfacilities: authorityUrl + '/getsafetyfacilities', //安全区标志信息获取
    operationsafetyfacility: authorityUrl + '/operationsafetyfacility', //安全区标志信息操作(safetyFacility)
    dictionays: {
        getintegratedictionarytree: apiUrl + '/diclist/getintegratedictionarytree', //新版字典获取树形
        getintegratedictionarylist: apiUrl + '/diclist/getintegratedictionarylist', //新版字典获取列表
        operationintegratedictionary: apiUrl + '/diclist/operationintegratedictionary', //新版字典操作(detail)
    },

    auditExamineDictionary: apiUrl + '/diclist/getdictionarylist', //新版字典操作(detail)
    dictionaysNew: {
        getintegratedictionarytree: apiUrl + '/diclist/getintegratedictionarytreenew', //新版字典获取树形
        getintegratedictionarylistNew: apiUrl + '/diclist/getintegratedictionarylistnew', //新版字典获取列表
        getintegratedictionarylist: apiUrl + '/diclist/getintegratedictionarylist', //新版字典获取列表
        operationintegratedictionary: apiUrl + '/diclist/operationdictionary', //新版字典操作(detail)
        operationintegratedictionarynew: apiUrl + '/diclist/operationintegratedictionarynew', //新版字典操作(detail)
    },

    //新版字典审核列表(detail)
    auditExamineDictionaryNew: apiUrl + '/diclist/getdictionaryauditlist', 
    //新字典审核操作
    operationauditdictionaryNew:apiUrl + '/diclist/operationauditdictionary', 


    //带有审核流程的字典
    newDict: {
        gettree: apiUrl + "/authority/gettree",//获取新版字典(树形)
        getdictionarylist: apiUrl + '/authority/getdictionarylist', //获取新版字典(列表)
        operationprocess: apiUrl + '/authority/operationprocess',//操作流程审批
        getprocesslist: apiUrl + '/authority/getprocesslist',//获取流程审批
        getnodetree: apiUrl + '/authority/getnodetree',//获取新版字典(引用省局字典库)
        quote: apiUrl + '/authority/quote',//引用字典(各局从省局字典库引用字典,同授权模块)
        operationnewdictionary: apiUrl + '/authority/operationnewdictionary'
    },
    //操作清单计量类项目
    workLoadList: {
        handle: workflowaddUrl + '/operationmeteringitem',
        query: workflowqueryUrl + '/getmeteringitems',
        tree: workflowqueryUrl + '/getmeteringitemstree'
    },
    /** 定量 */
    workflow: {
        /** 千寻巡查记录 */
        getdefect: apiUrl + '/qx/getdefect', //千寻巡查记录
        getsign: apiUrl + '/qx/getsign', //获取签名

        getrelevant: workflowqueryUrl + '/getrelevant', //病害单例反表单查询
        xuncha: workflowqueryUrl + '/getinspection',
        /**月计划 */
        getmaster: workflowqueryUrl + '/getmaster', //月作业主表查询
        createmaster: workflowaddUrl + '/createmaster', //月作业新增
        updatemaster: workflowaddUrl + '/updatemaster', //月作业更新
        submitmaster: workflowaddUrl + '/submitmaster', //月计划提交
        auditmaster: workflowaddUrl + '/auditmaster', //月作业审核提交

        withdraw: workflowaddUrl + '/sendbackjobplanmaster', //月作业审核提交
        delect: workflowaddUrl + '/deletejobplan', //月作业审核提交

        getplansublist: workflowqueryUrl + '/getplansublist', //子表查询
        createsublist: workflowaddUrl + '/createsublist', //子表新增
        updatesublist: workflowaddUrl + '/updatesublist', //子表修改
        getmasterlist: workflowqueryUrl + '/getmasterlist', //新作业计划
        getvalidmaster: workflowqueryUrl + '/getvalidmaster', //有效月计划获取
        operationjobplansublist: workflowaddUrl + "/operationjobplansublist", //月作业计划子操作
        /**巡查 */
        getinspection: workflowqueryUrl + '/getinspection', //巡查表格查询
        getinspectionsbynum: workflowqueryUrl + '/getinspectionsbynum', //巡查单例
        getlocus: apiUrl + '/workflowquery/getlocus', //巡查轨迹
        createinssublist: workflowaddUrl + '/createinssublist', //巡查子表新增
        updateinssublist: workflowaddUrl + '/updateinssublist', //巡查子表更新
        getdiseaselist: workflowqueryUrl + '/getdiseaselist', //新病害数据获取
        operationinspectionrecord: workflowaddUrl + '/operationinspectionrecord', //新主表操作
        operationinspectionrecordsublist: workflowaddUrl + '/operationinspectionrecordsublist', //新子表操作
        getexistproblem: workflowqueryUrl + '/getexistproblem', //问题记录获取
        operationexistproblem: workflowaddUrl + '/operationexistproblem', //问题记录操作(existProblemSublist)
        updatestatus: workflowaddUrl + '/updatestatus', //忽略问题
        /**小修 */
        getstatistics: workflowqueryUrl + '/getstatistics', //总览信息
        getminorlist: workflowqueryUrl + '/getminorlist', //主表表格（新）
        getminor: workflowqueryUrl + '/getminor', //主表单例（新）
        operationminor: workflowaddUrl + '/operationminor', //操作(新)
        /**安全布设 */
        getsafetylist: workflowqueryUrl + '/getsafetylist', //安全布设表格（新）
        getsafety: workflowqueryUrl + '/getsafety', //安全布设单例（新）
        operationsafety: workflowaddUrl + '/operationsafety', //操作(新)
        /**维修记录 */
        getmaintainlist: workflowqueryUrl + '/getmaintainlist', //主表表格（新）
        getmaintain: workflowqueryUrl + '/getmaintain', //主表单例（新）
        operationmaintain: workflowaddUrl + '/operationmaintain', //操作(新)

        /**验收申请 */
        getapplylist: workflowqueryUrl + '/getapplylist', //主表表格（新）
        getapply: workflowqueryUrl + '/getapply', //主表单例（新）
        operationapply: workflowaddUrl + '/operationapply', //操作(新)
        /**整改通知 */
        getrectifyList: workflowqueryUrl + '/getrectifylist', //主表表格（新）
        getrectify: workflowqueryUrl + '/getrectify', //主表单例（新）
        operationrectify: workflowaddUrl + '/operationrectify', //操作（新）
        /**验收记录 */
        getmaintaccept: workflowqueryUrl + '/getmaintaccept', //验收记录查询
        createmaintaccept: workflowaddUrl + '/createmaintaccept', //验收记录新增
        updatemaintaccept: workflowaddUrl + '/updatemaintaccept', //验收记录更新
        getacceptrecordcard: workflowqueryUrl + '/getacceptrecordcard', //验收记录卡片
        getacceptrecordcardbyd: workflowqueryUrl + '/getacceptrecordcardbyd', //验收记录卡片(病害)

        /**三大流程批量删除 rowCodes*/
        deleteinspectionlist: apiUrl + "/workflowadd/deleteinspectionlist", //删除巡查
        deletediseaselist: apiUrl + "/workflowadd/deletediseaselist", //病害删除
        deleteminorreport: apiUrl + "/workflowadd/deleteminorreport", //小修删除
        deletesafetylist: apiUrl + "/workflowadd/deletesafetylist", //安全布设删除
        deletemaintainlist: apiUrl + "/workflowadd/deletemaintainlist", //维修记录删除
        deleteapplylist: apiUrl + "/workflowadd/deleteapplylist", //验收申请
        deleterectificationlist: apiUrl + "/workflowadd/deleterectificationlist", //删除整改删除
        deletemaintacceptslist: apiUrl + "/workflowadd/deletemaintacceptslist", //验收作业记录删除
    },
    /**云采数据 */
    jsamapdata: {
        getjsamapdata: apiUrl + '/workflowquery/getjsamapdata', //云采数据查询
        getclouddatas: apiUrl + "/workflowquery/getclouddatas", //云采获取
        operationjsamapdata: apiUrl + '/workflowadd/operationjsamapdata', //云采数据操作
        operationclouddata: apiUrl + '/workflowadd/operationclouddata' //云采数据操作(cloudData)
    },
    /**业务考核 */
    businessAssess: {
        getbusinessassesses: apiUrl + '/meteringquery/getbusinessassesses', //业务考核列表
        operationbusinessassess: apiUrl + '/meteringoperation/operationbusinessassess', //业务考核操作(businessAssess)
    },
    /**普通干线 */
    everyday: {
        getmaster: everydayqueryUrl + '/getmaster', //月计划列表
        operationjobplan: everydayaddUrl + '/operationjobplan', //月计划操作
        getplansublist: everydayqueryUrl + '/getplansublist', //月作业子表列表
        operationjobplansublist: everydayaddUrl + '/operationjobplansublist', //月作业计划子表操作
        getmasterlist: everydayqueryUrl + '/getmasterlist', //月作业计划列表

        /**巡查记录 */
        getinspection: everydayqueryUrl + '/getinspection', //巡查列表
        getlocus: apiUrl + '/everydayquery/getlocus', //巡查轨迹
        operationinspectionrecord: everydayaddUrl + '/operationinspectionrecord', //新主表操作
        operationinspectionrecordsublist: everydayaddUrl + '/operationinspectionrecordsublist', //新子表操作
        /* 病害登记 */
        getdiseaselist: everydayqueryUrl + '/getdiseaselist', //病害列表
        createinssublist: everydayaddUrl + '/createinssublist', //病害操作新增
        updateinssublist: everydayaddUrl + '/updateinssublist', //病害操作编辑
        /**小修通报单 */
        getstatistics: everydayqueryUrl + '/getstatistics', //小修总览
        getminorlist: everydayqueryUrl + '/getminorlist', //小修通报列表
        getminor: everydayqueryUrl + '/getminor', //小修通报单例
        operationminor: everydayaddUrl + '/operationminor', //小修通报操作
        /**安全布设 */
        getsafetylist: everydayqueryUrl + '/getsafetylist', //安全布设列表
        getsafety: everydayqueryUrl + '/getsafety', //安全布设单例
        operationsafety: everydayaddUrl + '/operationsafety', //安全布设操作
        /**维修通知 */
        getmaintainlist: everydayqueryUrl + '/getmaintainlist', //维修通知列表
        getmaintain: everydayqueryUrl + '/getmaintain', //维修通知单例
        operationmaintain: everydayaddUrl + '/operationmaintain', //维修通知操作
        /**验收申请 */
        getapplylist: everydayqueryUrl + '/getapplylist', //验收申请列表
        getapply: everydayqueryUrl + '/getapply', //验收申请单例
        operationapply: everydayaddUrl + '/operationapply', //验收申请操作
        /**整改通知 */
        getrectifylist: everydayqueryUrl + '/getrectifylist', //整改通知列表
        getrectify: everydayqueryUrl + '/getrectify', //整改通知单例
        operationrectify: everydayaddUrl + '/operationrectify', //整改通知操作
        /**验收记录 */
        getmaintaccept: everydayqueryUrl + '/getmaintaccept', //验收记录列表
        operatioaceptrecord: everydayaddUrl + '/operatioaceptrecord', //验收记录操作
    },
    everydayX: {
        xuncha: everydayqueryUrl + '/getinspection',
        /**月计划 */
        getmaster: everydayqueryUrl + '/getmaster', //月作业主表查询
        createmaster: everydayaddUrl + '/createmaster', //月作业新增
        updatemaster: everydayaddUrl + '/updatemaster', //月作业更新
        submitmaster: everydayaddUrl + '/submitmaster', //月计划提交
        auditmaster: everydayaddUrl + '/auditmaster', //月作业审核提交

        withdraw: everydayaddUrl + '/sendbackjobplanmaster', //月作业审核提交
        delect: everydayaddUrl + '/deletejobplan', //月作业审核提交

        getplansublist: everydayqueryUrl + '/getplansublist', //子表查询
        createsublist: everydayaddUrl + '/createsublist', //子表新增
        updatesublist: everydayaddUrl + '/updatesublist', //子表修改
        getmasterlist: everydayqueryUrl + '/getmasterlist', //新作业计划

        withdraw: everydayaddUrl + '/sendbackjobplanmaster', //月作业审核提交
        delect: everydayaddUrl + '/deletejobplan', //月作业审核提交

        getvalidmaster: everydayqueryUrl + '/getvalidmaster', //有效月计划获取
        operationjobplansublist: everydayaddUrl + '/operationjobplansublist', //月作业计划子表操作
        /**巡查 */
        getinspection: everydayqueryUrl + '/getinspection', //巡查表格查询
        getinspectionsbynum: everydayqueryUrl + '/getinspectionsbynum', //巡查单例
        getlocus: apiUrl + '/everydayquery/getlocus', //巡查轨迹
        createinssublist: everydayaddUrl + '/createinssublist', //巡查子表新增
        updateinssublist: everydayaddUrl + '/updateinssublist', //巡查子表更新
        getdiseaselist: everydayqueryUrl + '/getdiseaselist', //新病害数据获取
        operationinspectionrecord: everydayaddUrl + '/operationinspectionrecord', //新主表操作
        operationinspectionrecordsublist: everydayaddUrl + '/operationinspectionrecordsublist', //新子表操作
        getexistproblem: everydayqueryUrl + '/getexistproblem', //问题记录获取
        operationexistproblem: everydayaddUrl + '/operationexistproblem', //问题记录操作(existProblemSublist)
        updatestatus: everydayaddUrl + '/updatestatus', //忽略问题
        /**小修 */
        getstatistics: everydayqueryUrl + '/getstatistics', //总览信息
        getminorlist: everydayqueryUrl + '/getminorlist', //主表表格（新）
        getminor: everydayqueryUrl + '/getminor', //主表单例（新）
        operationminor: everydayaddUrl + '/operationminor', //操作(新)
        /**安全布设 */
        getsafetylist: everydayqueryUrl + '/getsafetylist', //安全布设表格（新）
        getsafety: everydayqueryUrl + '/getsafety', //安全布设单例（新）
        operationsafety: everydayaddUrl + '/operationsafety', //操作(新)
        /**维修记录 */
        getmaintainlist: everydayqueryUrl + '/getmaintainlist', //主表表格（新）
        getmaintain: everydayqueryUrl + '/getmaintain', //主表单例（新）
        operationmaintain: everydayaddUrl + '/operationmaintain', //操作(新)
        /**机械使用记录 */

        /**验收申请 */
        getapplylist: everydayqueryUrl + '/getapplylist', //主表表格（新）
        getapply: everydayqueryUrl + '/getapply', //主表单例（新）
        operationapply: everydayaddUrl + '/operationapply', //操作(新)
        /**整改通知 */
        getrectifyList: everydayqueryUrl + '/getrectifylist', //主表表格（新）
        getrectify: everydayqueryUrl + '/getrectify', //主表单例（新）
        operationrectify: everydayaddUrl + '/operationrectify', //操作（新）
        /**验收记录 */
        getmaintaccept: everydayqueryUrl + '/getmaintaccept', //验收记录查询
        createmaintaccept: everydayaddUrl + '/createmaintaccept', //验收记录新增
        updatemaintaccept: everydayaddUrl + '/updatemaintaccept', //验收记录更新
    },
    /**定性 */
    qualitativeX: {
        /**月计划 */
        getmaster: qualitativequeryUrl + '/getmaster', //月作业主表查询
        createmaster: qualitativeaddUrl + '/createmaster', //月作业新增
        updatemaster: qualitativeaddUrl + '/updatemaster', //月作业更新
        submitmaster: qualitativeaddUrl + '/submitmaster', //月计划提交
        auditmaster: qualitativeaddUrl + '/auditmaster', //月作业审核提交

        withdraw: qualitativeaddUrl + '/sendbackjobplanmaster', //月作业审核提交
        delect: qualitativeaddUrl + '/deletejobplan', //月作业审核提交

        getplansublist: qualitativequeryUrl + '/getplansublist', //子表查询
        createsublist: qualitativeaddUrl + '/createsublist', //子表新增
        updatesublist: qualitativeaddUrl + '/updatesublist', //子表修改
        getmasterlist: qualitativequeryUrl + '/getmasterlist', //新作业计划



        getvalidmaster: qualitativequeryUrl + '/getvalidmaster', //有效月计划获取
        operationjobplansublist: qualitativeaddUrl + '/operationjobplansublist', //月作业计划子表操作
        /**安全布设 */
        getsafetylist: qualitativequeryUrl + '/getdxsafetylist', //安全布设表格（新）
        getsafety: qualitativequeryUrl + '/getdxsafety', //安全布设单例（新）
        operationsafety: qualitativeaddUrl + '/operationdxsafety', //操作(新)
        /**维修记录 */
        getmaintainlist: qualitativequeryUrl + '/getmaintainlist', //主表表格（新）
        getmaintain: qualitativequeryUrl + '/getmaintain', //主表单例（新）
        operationmaintain: qualitativeaddUrl + '/operationdxmaintain', //操作(新)
        /**整改通知 */
        getrectorder: qualitativequeryUrl + '/getrectifylist', //整改通知
        getrectify: qualitativequeryUrl + '/getrectify', //整改通知
        operationrectorder: qualitativeaddUrl + '/operationrectify', //整改通知操作
        /**验收记录*/
        getmaintaccept: qualitativequeryUrl + '/getmaintaccept', //验收记录查询
        //qualitativequeryUrl
        createmaintaccept: qualitativequeryUrl + '/createmaintaccept', //验收记录新增
        updatemaintaccept: qualitativequeryUrl + '/updatemaintaccept', //验收记录更新

        /**验收申请 */
        getapplylist: qualitativequeryUrl + '/getapplylist', //主表表格（新）
        getapply: qualitativequeryUrl + '/getapply', //主表单例（新）
        operationapply: qualitativeaddUrl + '/operationapply', //操作(新)
    },
    qualitative: {
        /**年度作业计划 */
        getannualjobs: qualitativequeryUrl + '/getannualjobs', //获取年度计划表格
        getjobsublist: qualitativequeryUrl + '/getjobsublist', // 获取年度计划表格(子表)
        getannualjobsyear: qualitativequeryUrl + '/getannualjobsyear', //获取本年度计划
        getupunit: qualitativequeryUrl + '/getupunit', //上级单位获取
        operationannualjob: qualitativeaddUrl + '/operationannualjob', //操作年度作业计划
        operationjobsublist: qualitativeaddUrl + '/operationjobsublist', //操作年度作业(子表)
        /**安全布设 */
        getsafety: qualitativequeryUrl + '/getsafety', //安全布设表格
        getauxiliary: qualitativequeryUrl + '/getauxiliary', //获取辅助信息
        operationsafety: qualitativeaddUrl + '/operationsafety', //安全布设操作
        operationauxiliary: qualitativeaddUrl + '/operationauxiliary', //辅助信息操作
        /**维修原始记录 */
        getmaintains: qualitativequeryUrl + '/getmaintains', //维修原始记录表格
        operationmaintain: qualitativeaddUrl + '/operationmaintain', //维修原始记录操作
        operationmaintainsublist: qualitativeaddUrl + '/operationmaintainsublist', //原始记录操作(子表)
        /**机械设备使用 */
        getfacility: qualitativequeryUrl + '/getfacility', //机械设备使用表格
        getfacilitysublist: qualitativequeryUrl + '/getfacilitysublist', //表格获取(子表)
        operationfacility: qualitativeaddUrl + '/operationfacility', //机械设备使用操作
        operationfacilitysublist: qualitativeaddUrl + '/operationfacilitysublist', //子表操作(子表)
        /**验收申请 */
        getapplylist: qualitativequeryUrl + '/getapplylist', //验收申请表格
        getaccapplylist: qualitativequeryUrl + '/getaccapplylist', //验收表格获取(子表)
        operationaccapply: qualitativeaddUrl + '/operationaccapply', //验收申请操作
        /**整改通知 */
        getrectorder: qualitativequeryUrl + '/getrectorder', //整改通知
        operationrectorder: qualitativeaddUrl + '/operationrectorder', //整改通知操作
        /**验收记录 */
        getmaintaccept: qualitativequeryUrl + '/getmaintaccept', //验收记录表格
        operationaccept: qualitativeaddUrl + '/operationaccept', //验收记录操作
    },
    /**
     * 路线
     */
    route: {
        search: basicdataqueryUrl + '/searchroute', //路线列表
        getroutebycode: basicdataqueryUrl + '/getroutebycode', //ID查询单例
        createroute: basicDataAddUrl + '/createroute', //路线新增
        updateroute: basicDataAddUrl + '/updateroute', //路线编辑
        deleteroute: basicDataAddUrl + '/deleteroute', //路线删除
        getchain: basicdataqueryUrl + '/getchain', //断链信息表
        createchain: basicDataAddUrl + '/createchain', //断链信息新增
        updatechain: basicDataAddUrl + '/updatechain', //断链信息编辑
        deletechain: basicDataAddUrl + '/deletechain', //断链信息删除
        getstatisticsdata: apiUrl + '/analysis/getstatisticsdata', //路线的报表

    },
    /*****路段 */
    roadSection: {
        getsections: basicdataqueryUrl + '/getsections', //列表页表格数据获取
        getsection2: basicdataqueryUrl + '/getsections2', //列表页表格汇总获取
        getsection: basicdataqueryUrl + '/getsection', //单例查询
        createsection: basicDataAddUrl + '/createsection', //数据新增
        updatesection: basicDataAddUrl + '/updatesection', //数据编辑
        deletesection: basicDataAddUrl + '/deletesection', //数据删除
        operationrepeatedsectionlist: basicDataAddUrl + '/operationrepeatedsectionlist', //重复路线信息(子表)(repeatedSectionList)
        getbdrepeateds: basicdataqueryUrl + '/getbdrepeateds', //重复路线信息(子表)
    },
    /******路网 */
    bdRoadNetwork: {
        getnetworks: basicdataqueryUrl + '/getnetworks', //主表表格
        getnetwork: basicdataqueryUrl + '/getnetwork', //主表单例查询
        creatnetwork: basicDataAddUrl + '/creatnetwork', //主表新增
        updatenetwork: basicDataAddUrl + '/updatenetwork', //主表修改
        deletenetwork: basicDataAddUrl + '/deletenetwork', //主表删除
        getnetworkbs: basicdataqueryUrl + '/getnetworkbs', //子表表格
        creatnetworkb: basicDataAddUrl + '/creatnetworkb', //子表新增
        deletenetworkb: basicDataAddUrl + '/deletenetworkb', //子表删除
    },
    /******路面结构-路面结构 ****/
    bdRouteStructureTable: {
        getstructure: basicdataqueryUrl + "/getstructure", //主表表格
        getsinglenetstruct: basicdataqueryUrl + "/getsinglenetstruct", //主表单例
        createstructure: basicDataAddUrl + "/createstructure", //主表新增
        updatestructure: basicDataAddUrl + "/updatestructure", //主表修改
        deletestructure: basicDataAddUrl + "/deletestructure", //主表删除
        getstructureb: basicdataqueryUrl + "/getstructureb", //子表表格
        createstructureb: basicDataAddUrl + "/createstructureb", //子表新增
        updatestructureb: basicDataAddUrl + "/updatestructureb", //子表修改
        deletestructureb: basicDataAddUrl + "/deletestructureb", //子表删除
    },
    /******路面结构-结构库 *****/
    bdStructureTemplateTable: {
        getstructtpl: basicdataqueryUrl + "/getstructtpl", //主表表格
        createstructtpl: basicDataAddUrl + "/createstructtpl", //主表新增
        updatestructtpl: basicDataAddUrl + "/updatestructtpl", //主表修改
        deletestructtpl: basicDataAddUrl + "/deletestructtpl", //主表删除
        singlestructtpl: basicdataqueryUrl + "/singlestructtpl", //子表单例查询
        getstructtpldetail: apiUrl + '/basicdataquery/getstructtpldetail', //子表查询
        createstructtpldetail: basicDataAddUrl + "/createstructtpldetail", //子表新增
        updatestructtpldetail: basicDataAddUrl + "/updatestructtpldetail", //子表修改
        deletestructtpldetail: basicDataAddUrl + "/deletestructtpldetail", //子表删除
    },
    /******路面结构-材料库 *****/
    bdStructureMaterial: {
        getmaterials: basicdataqueryUrl + "/getmaterials", //主表表格
        operationmaterial: basicDataAddUrl + "/operationmaterial", //主表操作
    },
    /*****路基-边坡 */
    bdSideSlope: {
        getsideslope: basicdataqueryUrl + '/getsideslope', //列表页表格数据获取
        sideslopebyid: basicdataqueryUrl + '/sideslopebyid', //单例查询
        createsideslope: basicDataAddUrl + '/createsideslope', //数据新增
        updatesideslope: basicDataAddUrl + '/updatesideslope', //数据编辑
        deletesideslope: basicDataAddUrl + '/deletesideslope', //数据删除
    },
    /******路基-排水设施 */
    bdDrainageFacility: {
        getdrainagefacility: basicdataqueryUrl + "/getdrainagefacility", //主表表格
        getfacilitybyid: basicdataqueryUrl + "/getfacilitybyid", //主表单例获取
        createdrainagefacility: basicDataAddUrl + "/createdrainagefacility", //主表新增
        updatedrainagefacility: basicDataAddUrl + "/updatedrainagefacility", //主表修改
        deletedrainagefacility: basicDataAddUrl + "/deletedrainagefacility", //主表删除
    },
    /*****交安设施 */
    appendant: {
        gettsafacilities: tsaFacilitiesQueryUrl + '/gettsafacilities', //交安设施管理表格获取
        download_gettsafacilities_export: tsaFacilitiesQueryUrl + '/download_gettsafacilities_export', //交安设施管理表格获取
        operationtsafacilities: tsaFacilitiesAddUrl + '/operationtsafacilities', //交安设施管理操作
        getantiglareboard: tsaFacilitiesQueryUrl + '/getantiglareboard', //防眩板
        getantiglarenet: tsaFacilitiesQueryUrl + '/getantiglarenet', //防眩网
        getattachedmark: tsaFacilitiesQueryUrl + '/getattachedmark', //附着式轮廓标
        getbridgeprotectnet: tsaFacilitiesQueryUrl + '/getbridgeprotectnet', //桥梁防护网
        getguardbar: tsaFacilitiesQueryUrl + '/getguardbar', //护栏
        gethundredbrand: tsaFacilitiesQueryUrl + '/gethundredbrand', //百米牌
        getinformationboard: tsaFacilitiesQueryUrl + '/getinformationboard', //可变情报板
        getbdIsolatedgrid: tsaFacilitiesQueryUrl + '/getbdIsolatedgrid', //隔离栅
        getpillarmark: tsaFacilitiesQueryUrl + '/getpillarmark', //柱式轮廓标
        getsignboard: tsaFacilitiesQueryUrl + '/getsignboard', //标志牌
        getmovablerail: tsaFacilitiesQueryUrl + '/getmovablerail', //活动护栏
        getsignline: tsaFacilitiesQueryUrl + '/getsignline', //标线---**********条件查询
        operationantiglareboard: tsaFacilitiesAddUrl + '/operationantiglareboard', //防眩板---**操作
        operationantiglarenet: tsaFacilitiesAddUrl + '/operationantiglarenet', //防眩网
        operationattachedmark: tsaFacilitiesAddUrl + '/operationattachedmark', //附着式轮廓标
        operationbridgeprotectnet: tsaFacilitiesAddUrl + '/operationbridgeprotectnet', //桥梁护网
        operationguardbar: tsaFacilitiesAddUrl + '/operationguardbar', //护栏
        operationhundredbrand: tsaFacilitiesAddUrl + '/operationhundredbrand', //百米牌
        operationinformationboard: tsaFacilitiesAddUrl + '/operationinformationboard', //可变情报板
        operationisolatedgrid: tsaFacilitiesAddUrl + '/operationisolatedgrid', //隔离栅
        operationpillarmark: tsaFacilitiesAddUrl + '/operationpillarmark', //柱式轮廓标
        operationsignboard: tsaFacilitiesAddUrl + '/operationsignboard', //标志牌
        operationsignline: tsaFacilitiesAddUrl + '/operationsignline', //标线
        operationmovablerail: tsaFacilitiesAddUrl + '/operationmovablerail', //活动护栏
    },
    /**桥隧涵字典获取 */
    getdictionary: diclistQueryUrl + '/getdictionary', //获取桥隧涵字典
    getdictionaries: apiUrl + '/authority/getdictionaries', //获取桥隧涵字典列表
    operationdictionary: apiUrl + '/authority/operationdictionary', //桥隧涵字典操作
    /**桥梁 */
    bridge: {
        getbridges: bridgequeryUrl + '/getbridges', //获取桥梁信息
        operationbridge: bridgeAddUrl + '/operationbridge', //操作桥梁
        getupstructures: bridgequeryUrl + "/getupstructures", //获取上部结构信息
        operationupstructure: bridgeAddUrl + '/operationupstructure', //操作上部结构
        getpiers: bridgequeryUrl + "/getpiers", //获取下部结构(墩台)信息
        operationabutmentpier: bridgeAddUrl + '/operationabutmentpier', //操作下部结构(墩台)信息
        getrepairrecords: bridgequeryUrl + '/getrepairrecords', //修建工程记录表格
        operationrepairrecord: bridgeAddUrl + '/operationrepairrecord', //修建工程记录操作
        getbridgecard: apiUrl + '/bridgequery/getbridgecard', //桥梁卡片信息
        getcomponents: bridgequeryUrl + '/getcomponents', //桥梁部件列表
        operationcomponent: bridgeAddUrl + '/operationcomponent', //桥梁部件操作
        getbridgesdata: apiUrl + "/analysis/getbridgesdata" //桥梁的报表
    },
    /**隧道 */
    tunnel: {
        gettunnels: tunnelQueryUrl + '/gettunnels', //隧道表格获取
        gettunnel: tunnelQueryUrl + '/gettunnel', //隧道单例查询
        operationtunnel: tunnelAddUrl + '/operationtunnel', //隧道操作
        getrepairrecords: tunnelQueryUrl + "/getrepairrecords", //隧道修建记录表格
        operationrepairrecord: tunnelAddUrl + "/operationrepairrecord", //隧道修建记录操作
        gettunnelcard: apiUrl + '/tunnelquery/gettunnelcard', //隧道卡片
        gettunnelsdata: apiUrl + "/analysis/gettunnelsdata" //隧道的统计

    },
    /**涵洞 */
    culvert: {
        getculverts: culvertqueryUrl + '/getculverts', //涵洞主表表格
        operationculvert: culvertaddUrl + '/operationculvert', //主表操作
        getrepairrecords: culvertqueryUrl + "/getrepairrecords", //涵洞修建记录表格
        operationrepairrecord: culvertaddUrl + "/operationrepairrecord", //涵洞修建记录操作
        getculvertcard: apiUrl + '/culvertquery/getculvertcard', //涵洞卡片
        getculvertsdata: apiUrl + '/analysis/getculvertsdata' //涵洞的统计
    },
    /**机械设备 */
    device: {
        getdevicelist: mechanicalQueryUrl + '/getdevicelist', //基础信息表格
        operationdevice: mechanicalAddUrl + '/operationdevice', //基础信息操作
        getdevicerepairrecord: mechanicalQueryUrl + '/getdevicerepairrecord', //保养记录查询
        operationrepairrecord: mechanicalAddUrl + '/operationrepairrecord', //保养记录操作
        getdeviceuserecords: mechanicalQueryUrl + '/getdeviceuserecords', //使用记录查询
        operationuserecord: mechanicalAddUrl + '/operationuserecord', //使用记录操作
    },
    /***辅助资产 ***/
    //仓库
    storehouse: {
        getstorehouses: storagequeryUrl + '/getstorehouses', //仓库表格查询
        getstorehouse: storagequeryUrl + '/getstorehouse', //仓库单例查询
        creatstorehouses: storageaddUrl + '/creatstorehouses', //仓库新增
        updatestorehouse: storageaddUrl + '/updatestorehouse', //仓库修改
        deletestorehouse: storageaddUrl + '/deletestorehouse', //仓库删除
    },
    //立体交叉
    interchange: {
        getinterchanges: storagequeryUrl + '/getinterchanges', //主表表格查询
        createinterchange: storageaddUrl + '/createinterchange', //主表新增
        updateinterchange: storageaddUrl + '/updateinterchange', //更新主表
        deleteinterchange: storageaddUrl + '/deleteinterchange', //删除主表
        getinterchangebs: storagequeryUrl + '/getinterchangebs', //子表查询
        createinterchangeb: storageaddUrl + '/createinterchangeb', //新增子表
        updateinterchangeb: storageaddUrl + '/updateinterchangeb', //更新子表
        deleteinterchangeb: storageaddUrl + '/deleteinterchangeb', //删除子表
    },
    //料场表
    materialField: {
        getmaterialfields: storagequeryUrl + '/getmaterialfields', //主表表格查询
        getmaterialfield: storagequeryUrl + '/getmaterialfield', //主表单例查询
        creatmaterialfield: storageaddUrl + '/creatmaterialfield', //主表新增
        updatematerialfield: storageaddUrl + '/updatematerialfield', //更新主表
        deletematerialfield: storageaddUrl + '/deletematerialfield', //删除主表
    },
    //拌合站表
    mixingStation: {
        getmixingstation: storagequeryUrl + '/getmixingstation', //主表表格查询
        getmixingstationbyid: storagequeryUrl + '/getmixingstationbyid', //主表单例查询
        createmixingstation: storageaddUrl + '/createmixingstation', //主表新增
        updatemixingstation: storageaddUrl + '/updatemixingstation', //更新主表
        deletemixingstation: storageaddUrl + '/deletemixingstation', //删除主表
    },
    //收费站表
    tollStation: {
        gettollstations: storagequeryUrl + '/gettollstations', //主表表格查询
        gettollstation: storagequeryUrl + '/gettollstation', //主表单例查询
        creattollstation: storageaddUrl + '/creattollstation', //主表新增
        updatetollstation: storageaddUrl + '/updatetollstation', //更新主表
        deletetollstation: storageaddUrl + '/deletetollstation', //删除主表
    },
    //交通量调查站表
    trafficFlowStation: {
        gettrafficflowstations: storagequeryUrl + '/gettrafficflowstations', //主表表格查询
        gettrafficflowstation: storagequeryUrl + '/gettrafficflowstation', //主表单例查询
        creattrafficflowstation: storageaddUrl + '/creattrafficflowstation', //主表新增
        updatetrafficflowstation: storageaddUrl + '/updatetrafficflowstation', //更新主表
        deletetrafficflowstation: storageaddUrl + '/deletetrafficflowstation', //删除主表
    },
    //养管站
    atubestation: {
        getatubestations: storagequeryUrl + '/getatubestations', //养管站列表查询
        operationatubestation: storageaddUrl + '/operationatubestation', //养管站操作(atubeStation)
    },
    /**养护材料(出入库) */
    storage: {
        getmaintainmaterial: storagequeryUrl + '/getmaintainmaterial', //养护材料表格查询
        getmaintainmaterialbyid: storagequeryUrl + '/getmaintainmaterialbyid', //养护材料单例查询
        createmaintainmaterial: storageaddUrl + '/createmaintainmaterial', //养护材料新增
        updatemaintainmaterial: storageaddUrl + '/updatemaintainmaterial', //养护材料修改
        deletemaintainmaterial: storageaddUrl + '/deletemaintainmaterial', //养护材料删除
        getmaterialenterstock: storagequeryUrl + '/getmaterialenterstock', //出入库表格查询
        getmaterialenterstockb: storagequeryUrl + '/getmaterialenterstockb', //出入库子表表格查询
        inmaterialenterstock: storageaddUrl + '/inmaterialenterstock', //入库
        outmaterialenterstock: storageaddUrl + '/outmaterialenterstock', //出库
        deletematerialenterstock: storageaddUrl + '/deletematerialenterstock', //删除出入库记录
    },
    /**
     * 电子档案管理
     */
    bridgeTunnel: {
        getbridgetunnels: apiUrl + "/erecordquery/getbridgetunnels", //列表获取
        operationbridgetunnel: apiUrl + "/erecordadd/operationbridgetunnel", //列表操作
    },
    files: {
        operationfileclass: apiUrl + '/maintenanceFile/operationfileclass', //文件分类
        gettreefileclasses: apiUrl + '/maintenancefile/gettreefileclasses', //分类获取
        operationfile: apiUrl + '/maintenanceFile/operationfile', //文件操作
        getefmmaterialfiles: apiUrl + '/maintenancefile/getefmmaterialfiles', //获取文件
    },
    maintenancefile: {
        getoilrepairfiles: maintenancefileUrl + '/getoilrepairfiles', //油路修补档案列表
        operationoilrepairfile: maintenancefileUrl + '/operationoilrepairfile', //油路修补档案操作(oilRepairFile)
        getrcrepairfiles: maintenancefileUrl + '/getrcrepairfiles', //路面裂缝修补档案列表
        operationrcrepairfile: maintenancefileUrl + '/operationrcrepairfile', //路面裂缝修补档案操作(rcRepairFile)
        getfacilitymaintenancefiles: maintenancefileUrl + '/getfacilitymaintenancefiles', //设施维修档案列表
        operationfacilitymaintenancefile: maintenancefileUrl + '/operationfacilitymaintenancefile', //设施维修档案操作(facilityMaintenanceFile)
        getbridgemaintenancefiles: maintenancefileUrl + '/getbridgemaintenancefiles', //桥梁维修档案列表
        operationbridgemaintenancefile: maintenancefileUrl + "/operationbridgemaintenancefile", //桥梁维修档案操作(bridgeMaintenanceFile)
        backbill: maintenancefileUrl + "/backbill" ,//维修档案操作(回退)

        getmaintainlist: maintenancefileUrl + "/getmaintainlist" ,//请求表数据
        addrcrepairfile: maintenancefileUrl + "/addrcrepairfile" ,//路面裂缝档案批量生成
        addoilrepairfile: maintenancefileUrl + "/addoilrepairfile" ,//油路修补档案批量生成
        addfacilitymaintenancefile: maintenancefileUrl + "/addfacilitymaintenancefile" ,//设施维修档案批量生成
        addbridgemaintenancefile: maintenancefileUrl + "/addbridgemaintenancefile" ,//桥梁维修档案批量生成
    },
    /**项目库 */
    projectLibrary: {
        getprojects: workflowqueryUrl + '/getprojects', //项目库列表
        createprojects: workflowaddUrl + '/createprojects', //项目库新增
        updateprojects: workflowaddUrl + '/updateprojects', //项目库编辑
        cancelprojects: workflowaddUrl + '/cancelprojects', //项目库作废
        createsecinfosublist: workflowaddUrl + '/createsecinfosublist', //合同段新增
        cancelsecinfosublist: workflowaddUrl + '/cancelsecinfosublist', //合同段作废
        createminormaintenproject: workflowaddUrl + '/createminormaintenproject', //高速小修新增
        cancelminormaintenproject: workflowaddUrl + '/cancelminormaintenproject', //高速小修作废
        creatauxiliarytransform: workflowaddUrl + '/creatauxiliarytransform', //路网改造新增
        cancelauxiliarytransform: workflowaddUrl + '/cancelauxiliarytransform', //路网改造作废
    },
    /**
     * 路网改造工程管理
     */
    roadNet: {
        getannualjobplans: roadnetqueryUrl + '/getannualjobplans', //年作业计划列表
        operationjobplan: roadnetoperationUrl + "/operationjobplan", //年作业计划操作(jobPlan)
        getunsafebridges: roadnetqueryUrl + '/getunsafebridges', //危桥改造项目列表
        operationunsafebridge: roadnetoperationUrl + "/operationunsafebridge", //危桥改造项目操作(unsafeBridge)
        getdisasterpreventions: roadnetqueryUrl + '/getdisasterpreventions', //灾害防治工程列表
        operationdisasterprevention: roadnetoperationUrl + '/operationdisasterprevention', //灾害防治工程操作(disaster)
        getsecurityengineerings: roadnetqueryUrl + "/getsecurityengineerings", //安保工程列表
        operationengineering: roadnetoperationUrl + '/operationengineering', //安保工程操作(engineering)

        getacceptanceapplies: roadnetqueryUrl + '/getacceptanceapplies', //交工验收申请列表
        operationacceptanceapply: roadnetoperationUrl + '/operationacceptanceapply', //交工验收申请操作(acceptanceApply)
        getacceptancecertificates: roadnetqueryUrl + '/getacceptancecertificates', //交工验收证书列表
        operationacceptancecertificate: roadnetoperationUrl + '/operationacceptancecertificate', //交工验收证书操作(acceptanceCertificate)
        getacceptancereports: roadnetqueryUrl + '/getacceptancereports', //交工验收报告列表
        operationacceptancereport: roadnetoperationUrl + '/operationacceptancereport', //交工验收报告操作(acceptanceReport)
        getqualityscores: roadnetqueryUrl + '/getqualityscores', //交工验收评分列表
        operationqualityscore: roadnetoperationUrl + '/operationqualityscore', //交工验收评分操作(qualityScore)

        getimevaluates: roadnetqueryUrl + '/getimevaluates', //管理综合评价列表
        operationimevaluate: roadnetoperationUrl + '/operationimevaluate', //管理综合评价操作(imEvaluate)
        getdesignworkces: roadnetqueryUrl + '/getdesignworkces', //设计工作综合评价列表
        operationdesignworkce: roadnetoperationUrl + '/operationdesignworkce', //设计工作综合评价操作(designWorkCe)
        getsuperviseces: roadnetqueryUrl + '/getsuperviseces', //监理工作综合评价列表
        operationsupervisece: roadnetoperationUrl + '/operationsupervisece', //监理工作综合操作(superviseCe)
        getcmces: roadnetqueryUrl + '/getcmces', //施工管理综合评价列表
        operationcmce: roadnetoperationUrl + '/operationcmce', //施工管理综合评价操作(cmce)

        getcacertificates: roadnetqueryUrl + '/getcacertificates', //工程竣工验收鉴定书列表
        operationcacertificate: roadnetoperationUrl + '/operationcacertificate', //工程竣工验收鉴定书操作(caCertificate)
        getcompletedqgs: roadnetqueryUrl + '/getcompletedqgs', //竣工验收委员会工程质量列表
        operationcompletedqg: roadnetoperationUrl + '/operationcompletedqg', //竣工验收委员会工程质量操作(completedQg)
        getcomplatedces: roadnetqueryUrl + '/getcomplatedces', //竣工验收项目综合评定列表
        operationcomplatedce: roadnetoperationUrl + '/operationcomplatedce', //竣工验收项目综合评定操作(complatedCe)
        getcompletedqes: roadnetqueryUrl + '/getcompletedqes', //竣工验收工程质量列表
        operationcompletedqe: roadnetoperationUrl + '/operationcompletedqe', //竣工验收工程重量操作(completedQe)
    },
    /**
     * 应急抢险管理
     */
    emergencyRescue: {
        /**新闻发布 */
        getnews: emergencyqueryUrl + '/getnews', //新闻发布列表
        operationemergencenew: emergencyoperationUrl + '/operationemergencenew', //新闻发布操作
        /**通知发布 */
        getnotices: emergencyqueryUrl + '/getnotices', //通知发布列表
        operationnotice: emergencyoperationUrl + '/operationnotice', //通知发布操作
        /**应急值班 */
        getemergenceduties: emergencyqueryUrl + '/getemergenceduties', //应急值班列表
        operationemergenceduty: emergencyoperationUrl + '/operationemergenceduty', //应急值班操作
        getemergencedutiebs: emergencyqueryUrl + '/getemergencedutiebs', //应急值班子表列表
        operationemergencedutyb: emergencyoperationUrl + '/operationemergencedutyb', //子表操作
        /**应急电话 */
        getphones: emergencyqueryUrl + '/getphones', //应急电话管理列表
        operationemergencephone: emergencyoperationUrl + '/operationemergencephone', //应急电话操作 emergencePhone
        /**应急预案 */
        getemergenceplans: emergencyqueryUrl + '/getemergenceplans', //应急预案列表
        operationemergenceplan: emergencyoperationUrl + '/operationemergenceplan', //应急预案操作 emergencePlan
        /**响应反馈 */
        getresponsefeedbacks: emergencyqueryUrl + '/getresponsefeedbacks', //响应反馈列表
        operationresponsefeedback: emergencyoperationUrl + '/operationresponsefeedback', //响应反馈操作 responseFeedback
        /**预警反馈 */
        getfeedbacks: emergencyqueryUrl + '/getfeedbacks', //预警反馈列表
        operationwarningfeedback: emergencyoperationUrl + '/operationwarningfeedback', //预警反馈操作 warningFeedback
        /**事件报送 */
        getreports: emergencyqueryUrl + '/getreports', //应急事件报送列表
        operationRreport: emergencyoperationUrl + '/operationRreport', //应急事件初报操作 emergencyReport
        operationreportcontinue: emergencyoperationUrl + '/operationreportcontinue', //应急事件续报操作 reportcontinue
        operationreportfinal: emergencyoperationUrl + '/operationreportfinal', //应急事件终报操作 reportfinal
        /**物资征用 */
        getrequestresources: emergencyqueryUrl + '/getrequestresources', //应急物资征用列表
        operationrequestresource: emergencyoperationUrl + '/operationrequestresource', //应急物资征用操作 requestResource
        getresourcesublist: emergencyqueryUrl + '/getresourcesublist', //物资征用子表列表
        operationresourcehuman: emergencyoperationUrl + '/operationresourcehuman', //人力物资操作 resourceHuman
        operationresourcedevice: emergencyoperationUrl + '/operationresourcedevice', //机械物资操作 resourceDevice
        operationresourcecar: emergencyoperationUrl + '/operationresourcecar', //车辆征用操作 resourceCar
        operationresourcematerial: emergencyoperationUrl + '/operationresourcematerial', //材料征用 resourceMaterial
        /**每日快报设置 */
        getexpresssets: emergencyqueryUrl + '/getexpresssets', //每日快报设置列表
        operationexpressset: emergencyoperationUrl + '/operationexpressset', //每日快报设置操作 expressSet
        /**每日快报 */
        getexpresses: emergencyqueryUrl + '/getexpresses', //每日快报列表
        getexpressebyid: emergencyqueryUrl + '/getexpressebyid', //每日快报单例 expressId
        operationexpress: emergencyoperationUrl + '/operationexpress', //每日快报操作 express
        operationexpressweather: emergencyoperationUrl + '/operationexpressweather', //天气信息操作 expressWeather
        operationexpresspatrol: emergencyoperationUrl + '/operationexpresspatrol', //当日巡查计划操作 expressPatrol
        operationclear: emergencyoperationUrl + '/operationclear', //应急保畅情况操作 clear
        operationcleardevice: emergencyoperationUrl + '/operationcleardevice', //应急保畅情况-设备 clearDevice
        operationclearmaterial: emergencyoperationUrl + '/operationclearmaterial', //应急保畅情况-物资 clearMaterial
        operationexpresswork: emergencyoperationUrl + '/operationexpresswork', //占道作业信息 expressWork
        operationexpressLoss: emergencyoperationUrl + '/operationexpressLoss', //路产损失情况 expressLoss
        operationexpresswarning: emergencyoperationUrl + '/operationexpresswarning', //预警信息 expressWarning

        getexpresssums: emergencyqueryUrl + "/getexpresssums", //每日快报汇总列表
        operationexpresssum: emergencyoperationUrl + '/operationexpresssum', //每日快报汇总操作 expressSum
    },
    /**
     * 桥隧涵数据管理
     */
    bTCCheck: {
        copybridgerunningchecks: bridgetunneloperationUrl + '/copydata',//桥梁经检复制

        getbridgeregularchecks: bridgetunneldataqueryUrl + '/getbridgeregularchecks', //桥梁定检查询
        operationbridgeregularcheck: bridgeTunnelOperationUrl + '/operationbridgeregularcheck', //桥梁定检操作(regularCheck)
        getbridgerunningchecks: bridgetunneldataqueryUrl + '/getbridgerunningchecks', //桥梁经检查询
        operationbridgerunningcheck: bridgeTunnelOperationUrl + '/operationbridgerunningcheck', //桥梁经检操作(runningCheck)
        getbridgespecialchecks: bridgetunneldataqueryUrl + '/getbridgespecialchecks', //桥梁特检查询
        operationbridgespecialcheck: bridgeTunnelOperationUrl + '/operationbridgespecialcheck', //桥梁特检操作(specialCheck)

        gettunnelregularchecks: bridgetunneldataqueryUrl + '/gettunnelregularchecks', //隧道定检查询
        operationtunnelregularcheck: bridgeTunnelOperationUrl + '/operationtunnelregularcheck', //隧道定检操作(regularCheck)
        gettunnelrunningchecks: bridgetunneldataqueryUrl + '/gettunnelrunningchecks', //隧道经检查询
        operationtunnelrunningcheck: bridgeTunnelOperationUrl + '/operationtunnelrunningcheck', //隧道经检操作(runningCheck)
        gettunnelspecialchecks: bridgetunneldataqueryUrl + '/gettunnelspecialchecks', //隧道专检查询
        operationtunnelspecialcheck: bridgeTunnelOperationUrl + '/operationtunnelspecialcheck', //隧道专检操作(specialCheck)
        getfacilityfaults: bridgetunneldataqueryUrl + '/getfacilityfaults', //隧道机电查询
        operationtunnelfacilityfault: bridgeTunnelOperationUrl + '/operationtunnelfacilityfault', //隧道机电操作(facilityFault)

        getculvertregularchecks: bridgetunneldataqueryUrl + '/getculvertregularchecks', //涵洞定检查询
        operationculvertregularcheck: bridgeTunnelOperationUrl + '/operationculvertregularcheck', //涵洞定检操作(regularCheck)
        getculvertrunningchecks: bridgetunneldataqueryUrl + '/getculvertrunningchecks', //涵洞经检查询
        operationculvertrunningcheck: bridgeTunnelOperationUrl + '/operationculvertrunningcheck', //涵洞经检操作(runningCheck)

        getacptapplylist: bridgetunneldataqueryUrl + '/getacptapplylist', //交工验收列表
        getacptapply: bridgetunneldataqueryUrl + '/getacptapply', //交工验收单例
        operationacptapply: bridgeTunnelOperationUrl + '/operationacptapply', //交工验收操作(acptApply)
        getacptcertlist: bridgetunneldataqueryUrl + '/getacptcertlist', //交工验收证书列表
        operationacptcert: bridgeTunnelOperationUrl + '/operationacptcert', //交工验收证书操作(acptCert)
        getacptreportlist: bridgetunneldataqueryUrl + '/getacptreportlist', //交工验收报告列表
        operationacptreport: bridgeTunnelOperationUrl + '/operationacptreport', //交工验收报告操作(acptReport)
        getacptqsgradelist: bridgetunneldataqueryUrl + '/getacptqsgradelist', //交工验收质量评分列表
        operationacptqsgrade: bridgeTunnelOperationUrl + '/operationacptqsgrade', //交工验收质量评分操作(acptQsGrade)

        getcommitteeqslist: bridgetunneldataqueryUrl + '/getcommitteeqslist', //委员会工程质量评价列表
        getacptcommitteeqs: bridgetunneldataqueryUrl + '/getacptcommitteeqs', //委员会工程质量评价单例
        operationacptcommitteeqs: bridgeTunnelOperationUrl + '/operationacptcommitteeqs', //委员会工程质量评价操作(acptCommitteeQs)
        getacptcompletedacpterlist: bridgetunneldataqueryUrl + '/getacptcompletedacpterlist', //竣工验收鉴定书列表
        getcompletedacpter: bridgetunneldataqueryUrl + '/getcompletedacpter', //竣工验收鉴定书单例
        operationcompletedacpter: bridgeTunnelOperationUrl + '/operationcompletedacpter', //竣工验收鉴定书操作(completedAcptEr)
        getacptcommitteelist: bridgetunneldataqueryUrl + '/getacptcommitteelist', //竣工验收委员会名单列表
        getacptcommittee: bridgetunneldataqueryUrl + '/getacptcommittee', //竣工验收委员会名单单例
        operationacptcommitteelist: bridgeTunnelOperationUrl + '/operationacptcommitteelist', //竣工验收委员会操作(acptCommitteeList)
        getacptbehaiflist: bridgetunneldataqueryUrl + '/getacptbehaiflist', //竣工验收代表名单列表
        getacptbehaif: bridgetunneldataqueryUrl + '/getacptbehaif', //竣工验收代表名单单例
        operationacptbehaiflist: bridgeTunnelOperationUrl + '/operationacptbehaiflist', //竣工验收代表名单操作(acptBehaifList)
        getacptqsassessmentlist: bridgetunneldataqueryUrl + '/getacptqsassessmentlist', //竣工验收工程质量评价列表
        getacptqsassessment: bridgetunneldataqueryUrl + '/getacptqsassessment', //竣工验收工程质量评价单例
        operationacptqsassessment: bridgeTunnelOperationUrl + '/operationacptqsassessment', //竣工验收工程质量评价操作(acptQsAssessment)

        getprojectcalist: bridgetunneldataqueryUrl + '/getprojectcalist', //综合评价列表
        getprojectca: bridgetunneldataqueryUrl + '/getprojectca', //综合评价单例
        operationprojectca: bridgeTunnelOperationUrl + '/operationprojectca', //综合评价操作(projectCa)
        getprojectconstructcalist: bridgetunneldataqueryUrl + '/getprojectconstructcalist', //施工管理综合评价列表
        getprojectconstructca: bridgetunneldataqueryUrl + '/getprojectconstructca', //施工管理综合评价单例
        operationprojectconstructca: bridgeTunnelOperationUrl + '/operationprojectconstructca', //施工管理综合评价操作(projectConstructCa)
        getprojectdesigncalist: bridgetunneldataqueryUrl + '/getprojectdesigncalist', //设计工作综合评价列表
        getprojectdesignca: bridgetunneldataqueryUrl + '/getprojectdesignca', //设计工作综合评价单例
        operationprojectdesignca: bridgeTunnelOperationUrl + '/operationprojectdesignca', //设计工作综合操作(projectConstructCa)
        getprojectsupervisingcalist: bridgetunneldataqueryUrl + '/getprojectsupervisingcalist', //监理工作综合评价列表
        getprojectsupervisingca: bridgetunneldataqueryUrl + '/getprojectsupervisingca', //监理工作综合评价单例
        operationprojectsupervisingca: bridgeTunnelOperationUrl + '/operationprojectsupervisingca', //监理工作综合评价操作(projectSupervisingCa)
    },
    /**
     * 维修专项工程
     */
    specialMaintenance: {
        getmaintainplan: specialMaintenanceUrl + '/getmaintainplan', //维修计划上报获取
        operationmaintainplan: specialmaintenanceoperationUrl + '/operationmaintainplan', //维修计划上报操作
        getmaintainprodesign: specialMaintenanceUrl + '/getmaintainprodesign', //维修工程设计获取
        operationmaintaindesign: specialmaintenanceoperationUrl + '/operationmaintaindesign', //维修工程设计操作
        operationdesignchange: specialmaintenanceoperationUrl + '/operationdesignchange', //计划变更操作
        getdesignchange: specialMaintenanceUrl + '/getdesignchange', //计划变更获取
        operationquantitalschange: specialmaintenanceoperationUrl + '/operationquantitalschange', //工程量和费用对照操作
        getacceptapply: specialMaintenanceUrl + '/getacceptapply', //交工验收申请列表
        operationacceptapply: specialmaintenanceoperationUrl + '/operationacceptapply', //交工验收申请操作(acceptApply)
        getcacertificate: specialMaintenanceUrl + '/getcacertificate', //维修工程竣工验收鉴定书列表
        operationcacertificate: specialmaintenanceoperationUrl + '/operationcacertificate', //维修工程竣工验收鉴定书列表(caCertificate)
        getcmce: specialMaintenanceUrl + '/getcmce', //施工管理综合评价列表
        operationcmce: specialmaintenanceoperationUrl + '/operationcmce', //施工管理综合评价操作(cmce)
        getcmceb: specialMaintenanceUrl + '/getcmceb', //施工管理综合评价子表列表
        operationcmceb: specialmaintenanceoperationUrl + '/operationcmceb', //施工管理综合评价子表操作(cmceb)
        getcomplatedce: specialMaintenanceUrl + '/getcomplatedce', //竣工验收项目综合评定表列表
        operationcomplatedce: specialmaintenanceoperationUrl + '/operationcomplatedce', //竣工验收项目综合评定操作(complatedCe)
        getcomplatedceb: specialMaintenanceUrl + '/getcomplatedceb', //竣工验收项目综合评价子表列表
        operationcomplatedceb: specialmaintenanceoperationUrl + '/operationcomplatedceb', //竣工验收项目综合评价子表操作(complatedCeb)
        getcompletedqe: specialMaintenanceUrl + '/getcompletedqe', //竣工验收工程质量评价列表
        operationcompletedqe: specialmaintenanceoperationUrl + '/operationcompletedqe', //竣工验收工程质量评价操作(completedQe)
        getcompletedqeb: specialMaintenanceUrl + '/getcompletedqeb', //竣工验收工程质量评价子表列表
        operationcompletedqeb: specialmaintenanceoperationUrl + '/operationcompletedqeb', //竣工验收工程质量评价子表操作(completedQeb)
        getcompletedqg: specialMaintenanceUrl + '/getcompletedqg', //竣工验收委员会工程质量评价列表
        operationcompletedqg: specialmaintenanceoperationUrl + '/operationcompletedqg', //竣工验收委员会工程质量评价操作(completedQg)
        getcompletedqgb: specialMaintenanceUrl + '/getcompletedqgb', //竣工验收委员会工程质量评价子表列表
        operationcompletedqgb: specialmaintenanceoperationUrl + '/operationcompletedqgb', //竣工验收委员会工程质量评价子表操作(completedQgb)
        getdelyworkaccept: specialMaintenanceUrl + '/getdelyworkaccept', //维修工程交工验收报告列表
        operationdelyworkaccept: specialmaintenanceoperationUrl + '/operationdelyworkaccept', //维修工程交工验收报告操作(delyworkAccept)
        getdesignchange: specialMaintenanceUrl + '/getdesignchange', //工程量费用变化列表(设计变更)
        operationdesignchange: specialmaintenanceoperationUrl + '/operationdesignchange', //工程量费用变化列表操作(maintainChange)
        getquantitalschange: specialMaintenanceUrl + '/getquantitalschange', //工程量费用变化子表列表
        operationquantitalschange: specialmaintenanceoperationUrl + '/operationquantitalschange', //工程量费用变化子表操作(complatedCeb)
        getdesignworkce: specialMaintenanceUrl + '/getdesignworkce', //设计工作综合评价列表
        operationdesignworkce: specialmaintenanceoperationUrl + '/operationdesignworkce', //设计工作综合评价操作(designWorkCe)
        getdesignworkceb: specialMaintenanceUrl + '/getdesignworkceb', //设计工作综合评价子表列表
        operationdesignworkceb: specialmaintenanceoperationUrl + '/operationdesignworkceb', //设计工作综合评价子表操作(designWorkCeb)
        getimevaluate: specialMaintenanceUrl + '/getimevaluate', //管理综合评价列表
        operationimevaluate: specialmaintenanceoperationUrl + '/operationimevaluate', //管理综合评价操作(imEvaluate)
        getimevaluateb: specialMaintenanceUrl + '/getimevaluateb', //管理综合评价子表列表
        operationimevaluateb: specialmaintenanceoperationUrl + '/operationimevaluateb', //管理综合评价子表操作(imEvaluateb)
        getlistingpayment: specialMaintenanceUrl + '/getlistingpayment', //清单期中支付列表
        operationlistingpayment: specialmaintenanceoperationUrl + '/operationlistingpayment', //清单期中支付操作(listingPayment)
        getlistingpaymentb: specialMaintenanceUrl + '/getlistingpaymentb', //清单期中支付子表列表
        operationlistingpaymentb: specialmaintenanceoperationUrl + '/operationlistingpaymentb', //清单期中支付子表操作(listingPaymentb)
        getapplycertificat: specialMaintenanceUrl + '/getapplycertificat', //维修工程交工验收证书列表
        operationapplycertificat: specialmaintenanceoperationUrl + '/operationapplycertificat', //维修工程交工验收证书操作(applyCertificat)
        getqsafterevaluate: specialMaintenanceUrl + '/getqsafterevaluate', //工程质量后评价列表
        operationqsafterevaluate: specialmaintenanceoperationUrl + '/operationqsafterevaluate', //工程质量后评价操作(qsAfterEvaluate)
        getqualityjobunit: specialMaintenanceUrl + '/getqualityjobunit', //质量责任卡承包单位列表
        operationqualityjobunit: specialmaintenanceoperationUrl + '/operationqualityjobunit', //质量责任卡承包单位操作(qualityJobUnit)
        getqualityscore: specialMaintenanceUrl + '/getqualityscore', //交工验收工程质量评分列表
        operationqualityscore: specialmaintenanceoperationUrl + '/operationqualityscore', //交工验收工程质量评分操作(qualityScore)
        getqualityscoreb: specialMaintenanceUrl + '/getqualityscoreb', //交工验收工程质量评分子表列表
        operationqualityscoreb: specialmaintenanceoperationUrl + '/operationqualityscoreb', //交工验收工程质量评分子表操作(qualityScoreb)
        getsupervisece: specialMaintenanceUrl + '/getsupervisece', //监理综合评价列表
        operationsupervisece: specialmaintenanceoperationUrl + '/operationsupervisece', //监理综合评价操作(superviseCe)
        getsuperviseceb: specialMaintenanceUrl + '/getsuperviseceb', //监理综合评价子表列表
        operationsuperviseceb: specialmaintenanceoperationUrl + '/operationsuperviseceb', //监理综合评价子表操作(superviseCeb)
    },
    /**
     * 桥隧维修加固工程
     */
    btreinforce: {
        getmaintainplan: btreinforceUrl + '/getmaintainplan', //维修计划上报获取
        operationmaintainplan: btreinforceoperationUrl + '/operationmaintainplan', //维修计划上报操作
        getmaintainprodesign: btreinforceUrl + '/getmaintainprodesign', //维修工程设计获取
        operationmaintaindesign: btreinforceoperationUrl + '/operationmaintaindesign', //维修工程设计操作
        operationdesignchange: btreinforceoperationUrl + '/operationdesignchange', //计划变更操作
        getdesignchange: btreinforceUrl + '/getdesignchange', //计划变更获取
        operationquantitalschange: btreinforceoperationUrl + '/operationquantitalschange', //工程量和费用对照操作
        getacceptapply: btreinforceUrl + '/getacceptapply', //交工验收申请列表
        operationacceptapply: btreinforceoperationUrl + '/operationacceptapply', //交工验收申请操作(acceptApply)
        getcacertificate: btreinforceUrl + '/getcacertificate', //维修工程竣工验收鉴定书列表
        operationcacertificate: btreinforceoperationUrl + '/operationcacertificate', //维修工程竣工验收鉴定书列表(caCertificate)
        getcmce: btreinforceUrl + '/getcmce', //施工管理综合评价列表
        operationcmce: btreinforceoperationUrl + '/operationcmce', //施工管理综合评价操作(cmce)
        getcmceb: btreinforceUrl + '/getcmceb', //施工管理综合评价子表列表
        operationcmceb: btreinforceoperationUrl + '/operationcmceb', //施工管理综合评价子表操作(cmceb)
        getcomplatedce: btreinforceUrl + '/getcomplatedce', //竣工验收项目综合评定表列表
        operationcomplatedce: btreinforceoperationUrl + '/operationcomplatedce', //竣工验收项目综合评定操作(complatedCe)
        getcomplatedceb: btreinforceUrl + '/getcomplatedceb', //竣工验收项目综合评价子表列表
        operationcomplatedceb: btreinforceoperationUrl + '/operationcomplatedceb', //竣工验收项目综合评价子表操作(complatedCeb)
        getcompletedqe: btreinforceUrl + '/getcompletedqe', //竣工验收工程质量评价列表
        operationcompletedqe: btreinforceoperationUrl + '/operationcompletedqe', //竣工验收工程质量评价操作(completedQe)
        getcompletedqeb: btreinforceUrl + '/getcompletedqeb', //竣工验收工程质量评价子表列表
        operationcompletedqeb: btreinforceoperationUrl + '/operationcompletedqeb', //竣工验收工程质量评价子表操作(completedQeb)
        getcompletedqg: btreinforceUrl + '/getcompletedqg', //竣工验收委员会工程质量评价列表
        operationcompletedqg: btreinforceoperationUrl + '/operationcompletedqg', //竣工验收委员会工程质量评价操作(completedQg)
        getcompletedqgb: btreinforceUrl + '/getcompletedqgb', //竣工验收委员会工程质量评价子表列表
        operationcompletedqgb: btreinforceoperationUrl + '/operationcompletedqgb', //竣工验收委员会工程质量评价子表操作(completedQgb)
        getdelyworkaccept: btreinforceUrl + '/getdelyworkaccept', //维修工程交工验收报告列表
        operationdelyworkaccept: btreinforceoperationUrl + '/operationdelyworkaccept', //维修工程交工验收报告操作(delyworkAccept)
        getdesignchange: btreinforceUrl + '/getdesignchange', //工程量费用变化列表(设计变更)
        operationdesignchange: btreinforceoperationUrl + '/operationdesignchange', //工程量费用变化列表操作(maintainChange)
        getquantitalschange: btreinforceUrl + '/getquantitalschange', //工程量费用变化子表列表
        operationquantitalschange: btreinforceoperationUrl + '/operationquantitalschange', //工程量费用变化子表操作(complatedCeb)
        getdesignworkce: btreinforceUrl + '/getdesignworkce', //设计工作综合评价列表
        operationdesignworkce: btreinforceoperationUrl + '/operationdesignworkce', //设计工作综合评价操作(designWorkCe)
        getdesignworkceb: btreinforceUrl + '/getdesignworkceb', //设计工作综合评价子表列表
        operationdesignworkceb: btreinforceoperationUrl + '/operationdesignworkceb', //设计工作综合评价子表操作(designWorkCeb)
        getimevaluate: btreinforceUrl + '/getimevaluate', //管理综合评价列表
        operationimevaluate: btreinforceoperationUrl + '/operationimevaluate', //管理综合评价操作(imEvaluate)
        getimevaluateb: btreinforceUrl + '/getimevaluateb', //管理综合评价子表列表
        operationimevaluateb: btreinforceoperationUrl + '/operationimevaluateb', //管理综合评价子表操作(imEvaluateb)
        getlistingpayment: btreinforceUrl + '/getlistingpayment', //清单期中支付列表
        operationlistingpayment: btreinforceoperationUrl + '/operationlistingpayment', //清单期中支付操作(listingPayment)
        getlistingpaymentb: btreinforceUrl + '/getlistingpaymentb', //清单期中支付子表列表
        operationlistingpaymentb: btreinforceoperationUrl + '/operationlistingpaymentb', //清单期中支付子表操作(listingPaymentb)
        getapplycertificat: btreinforceUrl + '/getapplycertificat', //维修工程交工验收证书列表
        operationapplycertificat: btreinforceoperationUrl + '/operationapplycertificat', //维修工程交工验收证书操作(applyCertificat)
        getqsafterevaluate: btreinforceUrl + '/getqsafterevaluate', //工程质量后评价列表
        operationqsafterevaluate: btreinforceoperationUrl + '/operationqsafterevaluate', //工程质量后评价操作(qsAfterEvaluate)
        getqualityjobunit: btreinforceUrl + '/getqualityjobunit', //质量责任卡承包单位列表
        operationqualityjobunit: btreinforceoperationUrl + '/operationqualityjobunit', //质量责任卡承包单位操作(qualityJobUnit)
        getqualityscore: btreinforceUrl + '/getqualityscore', //交工验收工程质量评分列表
        operationqualityscore: btreinforceoperationUrl + '/operationqualityscore', //交工验收工程质量评分操作(qualityScore)
        getqualityscoreb: btreinforceUrl + '/getqualityscoreb', //交工验收工程质量评分子表列表
        operationqualityscoreb: btreinforceoperationUrl + '/operationqualityscoreb', //交工验收工程质量评分子表操作(qualityScoreb)
        getsupervisece: btreinforceUrl + '/getsupervisece', //监理综合评价列表
        operationsupervisece: btreinforceoperationUrl + '/operationsupervisece', //监理综合评价操作(superviseCe)
        getsuperviseceb: btreinforceUrl + '/getsuperviseceb', //监理综合评价子表列表
        operationsuperviseceb: btreinforceoperationUrl + '/operationsuperviseceb', //监理综合评价子表操作(superviseCeb)
    },
    /**
     * 路网结构改造工程
     */
    lwjgreform: {
        getmaintainplan: lwjgreformUrl + '/getmaintainplan', //维修计划上报获取
        operationmaintainplan: lwjgreformoperationUrl + '/operationmaintainplan', //维修计划上报操作
        getmaintainprodesign: lwjgreformUrl + '/getmaintainprodesign', //维修工程设计获取
        operationmaintaindesign: lwjgreformoperationUrl + '/operationmaintaindesign', //维修工程设计操作
        operationdesignchange: lwjgreformoperationUrl + '/operationdesignchange', //计划变更操作
        getdesignchange: lwjgreformUrl + '/getdesignchange', //计划变更获取
        operationquantitalschange: lwjgreformoperationUrl + '/operationquantitalschange', //工程量和费用对照操作
        getacceptapply: lwjgreformUrl + '/getacceptapply', //交工验收申请列表
        operationacceptapply: lwjgreformoperationUrl + '/operationacceptapply', //交工验收申请操作(acceptApply)
        getcacertificate: lwjgreformUrl + '/getcacertificate', //维修工程竣工验收鉴定书列表
        operationcacertificate: lwjgreformoperationUrl + '/operationcacertificate', //维修工程竣工验收鉴定书列表(caCertificate)
        getcmce: lwjgreformUrl + '/getcmce', //施工管理综合评价列表
        operationcmce: lwjgreformoperationUrl + '/operationcmce', //施工管理综合评价操作(cmce)
        getcmceb: lwjgreformUrl + '/getcmceb', //施工管理综合评价子表列表
        operationcmceb: lwjgreformoperationUrl + '/operationcmceb', //施工管理综合评价子表操作(cmceb)
        getcomplatedce: lwjgreformUrl + '/getcomplatedce', //竣工验收项目综合评定表列表
        operationcomplatedce: lwjgreformoperationUrl + '/operationcomplatedce', //竣工验收项目综合评定操作(complatedCe)
        getcomplatedceb: lwjgreformUrl + '/getcomplatedceb', //竣工验收项目综合评价子表列表
        operationcomplatedceb: lwjgreformoperationUrl + '/operationcomplatedceb', //竣工验收项目综合评价子表操作(complatedCeb)
        getcompletedqe: lwjgreformUrl + '/getcompletedqe', //竣工验收工程质量评价列表
        operationcompletedqe: lwjgreformoperationUrl + '/operationcompletedqe', //竣工验收工程质量评价操作(completedQe)
        getcompletedqeb: lwjgreformUrl + '/getcompletedqeb', //竣工验收工程质量评价子表列表
        operationcompletedqeb: lwjgreformoperationUrl + '/operationcompletedqeb', //竣工验收工程质量评价子表操作(completedQeb)
        getcompletedqg: lwjgreformUrl + '/getcompletedqg', //竣工验收委员会工程质量评价列表
        operationcompletedqg: lwjgreformoperationUrl + '/operationcompletedqg', //竣工验收委员会工程质量评价操作(completedQg)
        getcompletedqgb: lwjgreformUrl + '/getcompletedqgb', //竣工验收委员会工程质量评价子表列表
        operationcompletedqgb: lwjgreformoperationUrl + '/operationcompletedqgb', //竣工验收委员会工程质量评价子表操作(completedQgb)
        getdelyworkaccept: lwjgreformUrl + '/getdelyworkaccept', //维修工程交工验收报告列表
        operationdelyworkaccept: lwjgreformoperationUrl + '/operationdelyworkaccept', //维修工程交工验收报告操作(delyworkAccept)
        getdesignchange: lwjgreformUrl + '/getdesignchange', //工程量费用变化列表(设计变更)
        operationdesignchange: lwjgreformoperationUrl + '/operationdesignchange', //工程量费用变化列表操作(maintainChange)
        getquantitalschange: lwjgreformUrl + '/getquantitalschange', //工程量费用变化子表列表
        operationquantitalschange: lwjgreformoperationUrl + '/operationquantitalschange', //工程量费用变化子表操作(complatedCeb)
        getdesignworkce: lwjgreformUrl + '/getdesignworkce', //设计工作综合评价列表
        operationdesignworkce: lwjgreformoperationUrl + '/operationdesignworkce', //设计工作综合评价操作(designWorkCe)
        getdesignworkceb: lwjgreformUrl + '/getdesignworkceb', //设计工作综合评价子表列表
        operationdesignworkceb: lwjgreformoperationUrl + '/operationdesignworkceb', //设计工作综合评价子表操作(designWorkCeb)
        getimevaluate: lwjgreformUrl + '/getimevaluate', //管理综合评价列表
        operationimevaluate: lwjgreformoperationUrl + '/operationimevaluate', //管理综合评价操作(imEvaluate)
        getimevaluateb: lwjgreformUrl + '/getimevaluateb', //管理综合评价子表列表
        operationimevaluateb: lwjgreformoperationUrl + '/operationimevaluateb', //管理综合评价子表操作(imEvaluateb)
        getlistingpayment: lwjgreformUrl + '/getlistingpayment', //清单期中支付列表
        operationlistingpayment: lwjgreformoperationUrl + '/operationlistingpayment', //清单期中支付操作(listingPayment)
        getlistingpaymentb: lwjgreformUrl + '/getlistingpaymentb', //清单期中支付子表列表
        operationlistingpaymentb: lwjgreformoperationUrl + '/operationlistingpaymentb', //清单期中支付子表操作(listingPaymentb)
        getapplycertificat: lwjgreformUrl + '/getapplycertificat', //维修工程交工验收证书列表
        operationapplycertificat: lwjgreformoperationUrl + '/operationapplycertificat', //维修工程交工验收证书操作(applyCertificat)
        getqsafterevaluate: lwjgreformUrl + '/getqsafterevaluate', //工程质量后评价列表
        operationqsafterevaluate: lwjgreformoperationUrl + '/operationqsafterevaluate', //工程质量后评价操作(qsAfterEvaluate)
        getqualityjobunit: lwjgreformUrl + '/getqualityjobunit', //质量责任卡承包单位列表
        operationqualityjobunit: lwjgreformoperationUrl + '/operationqualityjobunit', //质量责任卡承包单位操作(qualityJobUnit)
        getqualityscore: lwjgreformUrl + '/getqualityscore', //交工验收工程质量评分列表
        operationqualityscore: lwjgreformoperationUrl + '/operationqualityscore', //交工验收工程质量评分操作(qualityScore)
        getqualityscoreb: lwjgreformUrl + '/getqualityscoreb', //交工验收工程质量评分子表列表
        operationqualityscoreb: lwjgreformoperationUrl + '/operationqualityscoreb', //交工验收工程质量评分子表操作(qualityScoreb)
        getsupervisece: lwjgreformUrl + '/getsupervisece', //监理综合评价列表
        operationsupervisece: lwjgreformoperationUrl + '/operationsupervisece', //监理综合评价操作(superviseCe)
        getsuperviseceb: lwjgreformUrl + '/getsuperviseceb', //监理综合评价子表列表
        operationsuperviseceb: lwjgreformoperationUrl + '/operationsuperviseceb', //监理综合评价子表操作(superviseCeb)
    },
    /**
     * 人事管理
     */
    humanresources: {
        gethrbasics: humanresourcesUrl + '/gethrbasics', //获取
        operationhrbasicInformation: humanresourcesUrl + '/operationhrbasicInformation', //基础操作
        gethrinformationlist: apiUrl + "/humanresources/gethrinformationlist", //人事基础获取【新】
        operationhrinformation: apiUrl + "/humanresources/operationhrinformation", //人事基础操作(hrBasicInformation)【新】

        operationmonthlywages: apiUrl + "/humanresources/operationmonthlywages", //工资月报表操作
        gethrmonthlywages: apiUrl + "/humanresources/gethrmonthlywages", //工资月报表查询
        gethrmonthlywageslist: apiUrl + "/humanresources/gethrmonthlywageslist", //工资月报获取【新】
        operationhrmonthlywages: apiUrl + "/humanresources/operationhrmonthlywages", //工资月报操作(hrMonthlyWages)【新】

        gettreelist: apiUrl + '/humanResources/gettreelist', //人事组织机构获取
        getOrgTree: apiUrl + "/humanResources/GetOrgTree", //
        operationorganize: apiUrl + '/humanresources/operationorganize', //操作人事组织机构

        getdictionarys: apiUrl + '/humanresources/getdictionarys', //获取人事字典
        operationdetails: apiUrl + '/humanresources/operationdetails', //人事字典操作
        getdictionarybyname: apiUrl + '/humanresources/getdictionarybyname', //根据名称获取字典
    },
    /**
     * 路况评定
     */
    mqi: {
        getcelldivisions: cellDivisionUrl + '/getcelldivisions', //单元划分表格获取
        getcelldivisionsublists: cellDivisionUrl + '/getcelldivisionsublists', //子表获取
        dividecellnew: cellDivisionUrl + '/dividecellnew', //划分单元
        deletecelldivision: cellDivisionUrl + '/deletecelldivision', //单元划分删除
        operationweight: apiUrl + '/testdata/operationweight', //主表操作
        getmqiweights: apiUrl + '/testdata/getmqiweights', //主表查询
        operationindice: apiUrl + '/testdata/operationindice', //子表操作
        getindices: apiUrl + '/testdata/getindices', //子表获取
        operationtestbatch: apiUrl + '/testdata/operationtestbatch', //检测批次操作
        getmqitestbatches: apiUrl + '/testdata/getmqitestbatches', //检测批准查询
        operationpavementsisease: apiUrl + '/testdata/operationpavementsisease', //操作路面病害
        getmqipavementdiseases: apiUrl + '/testdata/getmqipavementdiseases', //路面病害查询
        getcelllist: apiUrl + '/cellDivision/getcelllist', // 明细
        getpitchdiseases: apiUrl + '/testdata/getpitchdiseases', //沥青路面病害查询
        operationpitchdisease: apiUrl + '/testdata/operationpitchdisease', //沥青路面病害操作
        getcementdiseases: apiUrl + '/testdata/getcementdiseases', //水泥路面病害查询
        operationcementdisease: apiUrl + '/testdata/operationcementdisease', //水泥路面病害操作
        getgravelroaddiseases: apiUrl + '/testdata/getgravelroaddiseases', //砂石路面病害查询
        operationgravelroaddisease: apiUrl + '/testdata/operationgravelroaddisease', //砂石路面病害操作
        operationpavementrut: apiUrl + '/testdata/operationpavementrut', //操作路面车辙主表
        getpavementruts: apiUrl + '/testdata/getpavementruts', //车辙检测数据主表条件查询
        operationpavementrutsublist: apiUrl + '/testdata/operationpavementrutsublist', //车辙路面子表操作
        getrutsublists: apiUrl + '/testdata/getrutsublists', //车辙路面子表查询
        getabrasions: apiUrl + '/testdata/getabrasions', //路面磨耗主表查询
        operationpavementabrasion: apiUrl + '/testdata/operationpavementabrasion', //路面磨耗主表操作
        getabrasionsublists: apiUrl + '/testdata/getabrasionsublists', //路面磨耗子表查询
        operationpavementabrasionsublist: apiUrl + '/testdata/operationpavementabrasionsublist', //路面磨耗子表操作
        getroadskidresistances: apiUrl + '/testdata/getroadskidresistances', //路面抗滑主表查询
        getresistancesublist: apiUrl + '/testdata/getresistancesublist', //路面抗滑子表查询
        operationskidresistance: apiUrl + '/testdata/operationskidresistance', //路面抗滑主表操作
        operationresistancesublist: apiUrl + '/testdata/operationresistancesublist', //路面抗滑子表操作
        getroadtrips: apiUrl + '/testdata/getroadtrips', //路面跳车主表查询
        getroadtripsublists: apiUrl + '/testdata/getroadtripsublists', //路面跳车子表查询
        operationroadtrip: apiUrl + '/testdata/operationroadtrip', //路面跳车主表操作
        operationroadtripsublist: apiUrl + '/testdata/operationroadtripsublist', //路面跳车子表操作
        getpavementdeflections: apiUrl + '/testdata/getpavementdeflections', //弯沉检测主表查询
        getdeflectiosublists: apiUrl + '/testdata/getdeflectiosublists', //弯沉检测子表查询
        operationpavementdeflection: apiUrl + '/testdata/operationpavementdeflection', //弯沉检测主表操作
        operationdeflectiosublist: apiUrl + '/testdata/operationdeflectiosublist', //弯沉检测子表操作
        getsurfaceevennesss: apiUrl + '/testdata/getsurfaceevennesss', //平整度主表查询
        getevennesssublists: apiUrl + '/testdata/getevennesssublists', //平整度子表查询
        operationsurfaceevenness: apiUrl + '/testdata/operationsurfaceevenness', //平整度主表操作
        operationevennesssublist: apiUrl + '/testdata/operationevennesssublist', //平整度子表操作
        operationfacilitisublist: apiUrl + '/testdata/operationfacilitisublist', //沿线设施子表操作
        operationroadsidefacilitie: apiUrl + '/testdata/operationroadsidefacilitie', //沿线设施主表操作
        getroadsidefacilities: apiUrl + '/testdata/getroadsidefacilities', //沿线设施主表查询
        getfacilitisublists: apiUrl + '/testdata/getfacilitisublists', //沿线设施子表查询
        getroadbeds: apiUrl + '/testdata/getroadbeds', //路基主表查询
        getroadbedsublists: apiUrl + '/testdata/getroadbedsublists', //路基子表查询
        operationroadbed: apiUrl + '/testdata/operationroadbed', //路基主表操作
        operationroadbedsublist: apiUrl + '/testdata/operationroadbedsublist', //路基子表操作
        getstructures: apiUrl + "/testdata/getstructures", //桥隧构造物主表查询
        operationstructure: apiUrl + '/testdata/operationstructure', //桥隧构造物主表操作
        getstructuresublists: apiUrl + '/testdata/getstructuresublists', //桥隧构造物子表查询
        operationstructuresublist: apiUrl + '/testdata/operationstructuresublist', //桥隧构造物子表操作
        getevaluationmanagements: apiUrl + '/trafficassess/getevaluationmanagements', //评定管理(testBatchNo)
        dataverified: apiUrl + '/testdata/dataverified', //检测批次完整性校验(testBatchCode检测批次id)
        regressionmodelasync: apiUrl + '/modellibrary/regressionmodelasync', //路线模型回归
        getmqinationals: apiUrl + '/trafficassess/getmqinationals', //国检评定列表
        getmqinationalsublists: apiUrl + '/trafficassess/getmqinationalsublists', //国检评定子表列表
        dataassess: apiUrl + '/trafficassess/dataassess', //国检计算
        operationassess: apiUrl + '/trafficassess/operationassess', //国检保存(assess)
        getrouteassess: apiUrl + '/trafficassess/getrouteassess', //路线评定
        createrouteassess: apiUrl + '/trafficassess/createrouteassess', //路线评定操作(assessManagementCode,drivingDirection)
        operationrouteassess: apiUrl + '/trafficassess/operationrouteassess', //路线评定保存(assess)
        getroadnetworkassess: apiUrl + '/trafficassess/getroadnetworkassess', //路网获取
        gettestbatchbyroadnetworkid: apiUrl + '/trafficassess/gettestbatchbyroadnetworkid', //根据路网id获取路线信息检测批次(roadNetWorkId)
        getroadnetworkassessbs: apiUrl + '/trafficassess/getroadnetworkassessbs', //选择路网后,获取路网下的路段信息和检查匹配信息
        gettestbatchbyidandyears: apiUrl + '/trafficassess/gettestbatchbyidandyears', //根据年度获取(testBatchDate,routeIds)
        getothersbatchlist: apiUrl + '/trafficassess/getothersbatchlist', //根据路网、路线id和年度获取除此之外的检测批次信息
        createroadnetworkassess: apiUrl + '/trafficassess/createroadnetworkassess', //创建路网评定(rowCode,drivingDirection)
        roadnetworkassess: apiUrl + '/trafficassess/roadnetworkassess', //执行评定操作
        saveroadnetworkassess: apiUrl + '/trafficassess/saveroadnetworkassess', //保存路网评定
        gettrafficassesselist: apiUrl + '/trafficassess/gettrafficassesselist', //路况评定汇总
        gettechnicalstatuswarninglist: apiUrl + '/trafficassess/gettechnicalstatuswarninglist', //路况预警获取
        operationwarningstandard: apiUrl + '/trafficassess/operationwarningstandard', //预警模式操作
        getwarningstandards: apiUrl + '/trafficassess/getwarningstandards', //预警模式查询
    },

    /**养护单位管理 */
    maintenanceUnit: {
        getmuconstructionunits: apiUrl + '/maintenanceunitquery/getmuconstructionunits', //施工单位获取
        operationconstructionunit: apiUrl + '/maintenanceunitoperation/operationconstructionunit', //施工单位操作
        getreviewmaterials: apiUrl + '/maintenanceunitquery/getreviewmaterials', //从业资质材料查询
        operationreviewmaterial: apiUrl + '/maintenanceunitoperation/operationreviewmaterial', //从业资质操作
        operationpointsdetail: apiUrl + '/maintenanceunitoperation/operationpointsdetail', //失信行为操作
        getpointsdetails: apiUrl + '/maintenanceunitquery/getpointsdetails', //失信行为查询
        operationcreditrating: apiUrl + '/maintenanceunitoperation/operationcreditrating', //信用评价操作
        getcreditratings: apiUrl + '/maintenanceunitquery/getcreditratings', //信用评价查询
        getcreditpoints: apiUrl + '/maintenanceunitquery/getcreditpoints', //扣分明显获取
    },
    /**
     * 计量支付
     */
    measurementAndPayment: {
        getbillofquantities: apiUrl + "/meteringquery/getbillofquantities", //清单工程量变更条件查询
        operationbillofquantitieschanged: apiUrl + '/meteringoperation/operationbillofquantitieschanged', //清单工程量变更操作
        getpriceadjustcalculates: apiUrl + '/meteringquery/getpriceadjustcalculates', //价格调整计算查询
        operationpriceadjustcalculate: apiUrl + '/meteringoperation/operationpriceadjustcalculate', //价格调整计算操作
        getlistmidtermpayments: apiUrl + '/meteringquery/getlistmidtermpayments', //清单期中支付查询
        operationlistmidtermpayment: apiUrl + '/meteringoperation/operationlistmidtermpayment', //清单期中支付操作
        getpaymentcerts: apiUrl + '/meteringquery/getpaymentcerts', //期中财务支付证书查询
        operationmidtermfinancepaymentcert: apiUrl + '/meteringoperation/operationmidtermfinancepaymentcert', //期中财务支付证书操作


        getpaymentinterimlist: apiUrl + '/measurepayment/getpaymentinterimlist', //获取清单中期支付报表
        getpaymentinterimsublistlist: apiUrl + "/measurepayment/getpaymentinterimsublistlist", //获取清单中期支付报表明细
        operationfinancialinterim: apiUrl + "/measurepayment/operationfinancialinterim", //操作清单中期支付报表>financialInterim
        getpaymentsummarylist: apiUrl + '/measurepayment/getpaymentsummarylist', //获取中间计量支付汇总表
        getpaymentsummarysublistlist: apiUrl + "/measurepayment/getpaymentsummarysublistlist", //获取中间计量支付汇总表子项
        getpaymentfinancialinterimlist: apiUrl + '/measurepayment/getpaymentfinancialinterimlist', //获取财务中期支付表
        createpaymentfinancialinterim: apiUrl + '/measurepayment/createpaymentfinancialinterim', //生成财务中期支付
        getpaymentprojectlist: apiUrl + '/measurepayment/getpaymentprojectlist', //获取工程进度表
        operationprojectplan: apiUrl + '/measurepayment/operationprojectplan', //操作计划信息>projectPlan
    },
    /**
     * 灾害水毁
     */
    disasterWaterDamage: {
        getreports: apiUrl + '/waterloggingdisasterquery/getreports', //获取灾害水毁统计上报
        getreportbyid: apiUrl + '/waterloggingdisasterquery/getreportbyid', //灾害水毁统计上报单例查询
        operationreport: apiUrl + '/waterloggingdisasteroperation/operationreport', // 灾害水毁统计上报操作
        operationreportstatistics: apiUrl + '/waterloggingdisasteroperation/operationreportstatistics', // 灾害水毁统计上报子表操作
        getreportrobs: apiUrl + '/waterloggingdisasterquery/getreportrobs', //获取抢通情况
        operationreportrob: apiUrl + '/waterloggingdisasteroperation/operationreportrob', //抢通情况操作
        getreportrepairs: apiUrl + '/waterloggingdisasterquery/getreportrepairs', //获取水毁修复主表
        operationreportrepair: apiUrl + "/waterloggingdisasteroperation/operationreportrepair", //水毁修复
        getlossrepairsums: apiUrl + '/waterloggingdisasterquery/getlossrepairsums', //获取公路灾毁损失和抢通情况统计
        operationlossrepairsum: apiUrl + "/waterloggingdisasteroperation/operationlossrepairsum", //公路灾毁损失和抢通情况统计操作
        getlosssums: apiUrl + '/waterloggingdisasterquery/getlosssums', //获取公路灾毁损失和抢通情况统计(损失情况列表)
        operationlosssum: apiUrl + '/waterloggingdisasteroperation/operationlosssum', //获取公路灾毁损失和抢通情况统计(损失情况操作)
        getrepairsums: apiUrl + '/waterloggingdisasterquery/getrepairsums', //获取公路灾毁损失和抢通情况统计(抢通情况列表)
        operationrepairsum: apiUrl + '/waterloggingdisasteroperation/operationrepairsum', //获取公路灾毁损失和抢通情况统计(抢通情况操作)
        getreconstructionplans: apiUrl + '/waterloggingdisasterquery/getreconstructionplans', //获取灾毁恢复重建项目建议计划
        getreportstatistics: apiUrl + '/waterloggingdisasterquery/getreportstatistics', //获取灾毁情况统计子表
        operationreconstructionplan: apiUrl + '/waterloggingdisasteroperation/operationreconstructionplan', //灾毁恢复重建项目建议计划操作
    },
    /**
     * 交通量
     */
    trafficData: {
        gettrafficflowstations: apiUrl + '/trafficvolume/gettrafficflowstations', //获取相关交通检测站
        gettrafficvolumeparameters: apiUrl + '/trafficvolume/gettrafficvolumeparameters', //交通量参数库查询
        operationtrafficvolumeparameter: apiUrl + '/trafficvolume/operationtrafficvolumeparameter', //交通量参数库操作
        getmodellibrarys: apiUrl + '/trafficvolume/getmodellibrarys', //代表车型库查询
        operationmodellibrary: apiUrl + '/trafficvolume/operationmodellibrary', //代表车型库操作
        getconversionfactors: apiUrl + '/trafficvolume/getconversionfactors', //车型转换系数条件查询
        operationconversionfactors: apiUrl + '/trafficvolume/operationconversionfactors', //车型转换系数批量操作
        gettrafficdatas: apiUrl + '/trafficvolume/gettrafficdatas', //交通量数据条件查询
        operationtrafficdata: apiUrl + '/trafficvolume/operationtrafficdata', //交通量数据操作
        gettrafficdatasublists: apiUrl + '/trafficvolume/gettrafficdatasublists', //交通量数据子表条件查询
        operationtrafficdatasublist: apiUrl + '/trafficvolume/operationtrafficdatasublist', //交通量数据子表操作
        gettrafficreports: apiUrl + '/trafficvolume/gettrafficreports', //交通量报表条件查询
        aoperationtrafficreporta: apiUrl + '/trafficvolume/operationtrafficreport', //交通量报表操作
        getttrafficreportsublists: apiUrl + '/trafficvolume/getttrafficreportsublists', //交通量报表子表条件查询
        operationttrafficreportsublist: apiUrl + '/trafficvolume/operationttrafficreportsublist', // 操作交通量报表子表
        gettrafficmanagements: apiUrl + '/trafficvolume/gettrafficmanagements', //交通量管理
        getaxleloads: apiUrl + '/trafficvolume/getaxleloads', //年累计当量轴载查询
        operationaxleload: apiUrl + '/trafficvolume/operationaxleload', //年累计当量轴载操作
    },
    /**
     * 决策基础
     */
    measureslibrary: {
        /**模型库 */
        getrsmodels: apiUrl + '/modellibrary/getrsmodels', //路面模型库查询
        operationrsmodel: apiUrl + '/modellibrary/operationrsmodel', //路面模型库操作(rsModel)
        getrsmodelrs: apiUrl + '/modellibrary/getrsmodelrs', //路面模型校正
        getbridgemodels: apiUrl + '/modellibrary/getbridgemodels', //桥梁模型库查询
        operationbridgemodel: apiUrl + '/modellibrary/operationbridgemodel', //桥梁模型库操作(bridgeModel)
        getbridgemodelrs: apiUrl + '/modellibrary/getbridgemodelrs', //桥梁模型校正
        gettunnelmodels: apiUrl + '/modellibrary/gettunnelmodels', //隧道模型库查询
        operationtunnelmodel: apiUrl + '/modellibrary/operationtunnelmodel', //隧道模型库操作(tunnelModel)
        gettunnelmodelrs: apiUrl + '/modellibrary/gettunnelmodelrs', //隧道模型校正
        /**措施库 */
        getrsmeasures: apiUrl + '/measureslibrary/getrsmeasures', //路面养护措施库列表
        operationrsmeasure: apiUrl + '/measureslibrary/operationrsmeasure', //路面养护措施库操作(rsMeasure)
        getbridgemeasures: apiUrl + '/measureslibrary/getbridgemeasures', //桥梁养护措施库查询
        operationbridgemeasure: apiUrl + '/measureslibrary/operationbridgemeasure', //桥梁养护措施库操作(bridgeMeasure)
        gettunnelmeasures: apiUrl + '/measureslibrary/gettunnelmeasures', //隧道养护措施库列表
        operationtunnelmeasure: apiUrl + '/measureslibrary/operationtunnelmeasure', //隧道养护措施库操作(tunnelMeasure)
        /**单价库 */
        getdmcibenchmarks: apiUrl + '/unitpricelibrary/getdmcibenchmarks', //养护费用指标基准库列表
        operationdmcibenchmark: apiUrl + '/unitpricelibrary/operationdmcibenchmark', //费用指标基准库操作(dmciBenchmark)
        getcmicoefficients: apiUrl + '/unitpricelibrary/getcmicoefficients', //指标调整系数表列表
        operationcmicoefficient: apiUrl + '/unitpricelibrary/operationcmicoefficient', //指标调整系数表操作(cmiCoefficient)
        getmmequotas: apiUrl + '/unitpricelibrary/getmmequotas', //小修保养工程定额库列表
        operationmmequota: apiUrl + '/unitpricelibrary/operationmmequota', //小修保养工程定额库操作(mmeQuota)
        getdmunitpricelibrarys: apiUrl + '/unitpricelibrary/getdmunitpricelibrarys', //单价库列表
        operationdmunitpricelibrary: apiUrl + '/unitpricelibrary/operationdmunitpricelibrary', //单价库操作(dmUnitPriceLibrary)
        getoeunitpricelibrarys: apiUrl + '/unitpricelibrary/getoeunitpricelibrarys', //其余工程养护单价库列表
        operationoeunitpricelibrary: apiUrl + '/unitpricelibrary/operationoeunitpricelibrary', //其余工程养护单价库操作(oeUnitPriceLibrary)
        /**参数库 */
        getsectionmaintenances: apiUrl + '/parameterslibrary/getsectionmaintenances', //路段划分方法查询
        operationsectionmaintenance: apiUrl + '/parameterslibrary/operationsectionmaintenance', //路段划分方法操作(sectionMaintenance)
        getbridgemaintenances: apiUrl + '/parameterslibrary/getbridgemaintenances', //桥梁分类养护方法列表
        operationbridgemaintenance: apiUrl + '/parameterslibrary/operationbridgemaintenance', //桥梁分类养护方法操作(bridgeMaintenance)
        deletebridgemaintenancesublist: apiUrl + '/parameterslibrary/deletebridgemaintenancesublist', //桥梁分类方法子表删除
        gettunnelmaintenances: apiUrl + '/parameterslibrary/gettunnelmaintenances', //隧道分类养护方法查询
        operationtunnelmaintenance: apiUrl + '/parameterslibrary/operationtunnelmaintenance', //隧道分类养护方法操作(tunnelMaintenance)
        operationpitchmeasure: apiUrl + '/pavementmdpm/operationpitchmeasure', //沥青路面预防性养护初选措施库操作
        getpitchmeasures: apiUrl + '/pavementmdpm/getpitchmeasures', //沥青路面预防性养护初选库条件查询
        getcementmeasures: apiUrl + '/pavementmdpm/getcementmeasures', //水泥路面预防性养护初选库条件查询
        operationcementmeasure: apiUrl + '/pavementmdpm/operationcementmeasure', //水泥路面预防性养护初选措施库操作
        operationsandmeasure: apiUrl + '/pavementmdpm/operationsandmeasure', //砂石路面预防性养护初选措施库操作
        getsandmeasures: apiUrl + "/pavementmdpm/getsandmeasures", //砂石路面预防性养护初选库条件查询
        operationmeasuref: apiUrl + '/pavementmdpm/operationmeasuref', //预防性养护措施的使用寿命与单位费用范围条件操作
        getpmmeasurefs: apiUrl + '/pavementmdpm/getpmmeasurefs', // 预防性养护措施的使用寿命与单位费用范围条件查询
        getpmifws: apiUrl + '/pavementmdpm/getpmifws', //不同等级公路的影响因素权重系数Wi条件查询
        operationpmifw: apiUrl + '/pavementmdpm/operationpmifw', //不同等级公路的影响因素权重系数Wi操作
        getattributescores: apiUrl + '/pavementmdpm/getattributescores', //各常用预防性养护措施的属性分值范围Cij条件查询
        operationattributescore: apiUrl + '/pavementmdpm/operationattributescore', //各常用预防性养护措施的属性分值范围Cij操作

    },
    /**数据报表 */
    echarts: {
        getmaintainmonthly: apiUrl + '/analysis/getmaintainmonthly', //日常养护维修月报
        getmonthlyreport: apiUrl + '/analysis/getmonthlyreport', //维修月报表
        getanalysisa: apiUrl + '/analysis/getanalysisa', //数据中心-获取当月发生病害情况
        getanalysisadetails: apiUrl + '/analysis/getanalysisadetails', //数据中心-获取病害明细
        getanalysisb: apiUrl + '/analysis/getanalysisb', //数据中心-巡查里程+当日病害数量+APP在线
        getanalysisc: apiUrl + '/analysis/getanalysisc', //数据中心-获取地图
        projectdata: apiUrl + '/analysis/projectdata', //数据中心-获取项目库
        getanalysisd: apiUrl + '/analysis/getanalysisd', //数据中心-近3年技术状况评定
        getmaintenance: apiUrl + '/analysis/getmaintenance', //日常养护统计

        getroutetotal: apiUrl + '/analysis/getroutetotal',//获取路线信息(数据中心)
        getbridgetotal: apiUrl + '/analysis/getbridgetotal',//获取桥梁信息(数据中心)
        gettunneltotal: apiUrl + '/analysis/gettunneltotal',//获取隧道信息(数据中心)
        getculverttotal: apiUrl + '/analysis/getculverttotal',//获取涵洞信息(数据中心)
        getfacilitiestotal: apiUrl + '/analysis/getfacilitiestotal',//获取交安信息(数据中心)

        getapview: apiUrl + '/analysis/getapview',//获取年度计划与完成情况(数据中心)
        getpdtsview: apiUrl + '/analysis/getpdtsview',//获取路面病害处治完成情况(数据中心)
        getmdtsview: apiUrl + '/analysis/getmdtsview',//获取主要病害处治情况(数据中心)
        getdsview: apiUrl + '/analysis/getdsview',//获取近五年病害数据统计(数据中心)

        getroadsurveypavementlist: apiUrl + '/celldivision/getroadsurveypavementlist',//路况调查数据获取(管养单位统计)
        getroadsurveypavements: apiUrl + '/celldivision/getroadsurveypavements',//路况调查数据获取(路线统计)

        getwarninganalysislist: apiUrl + '/warning/getwarninganalysislist',//路面监测
        getwarninglist: apiUrl + '/warning/getwarninglist',//路面监测列表
        confirmwarning: apiUrl + '/warning/confirmwarning',//确认监测告警
    },
    /*公路养护质量等级评定条件查询*/
    hmqrAscoreUrl: new HmqrAscoreUrl(baseUrl),
    inventoryList: new InventoryList(baseUrl),
    notices: new Notices(baseUrl),
    homeNotices: {
        query: apiUrl + '/notice/getnoticelist', //
        handle: apiUrl + '/notice/operationnotice', //
        inbox: apiUrl + '/notice/getselfnoticelist', //
        read: apiUrl + '/notice/updateflag', //
        status: apiUrl + '/notice/getflagnumber', //
    },
    indexUrl: new IndexUrl(baseUrl),
    decision: new Decision(baseUrl), //策略
    downloads: downloads, //下载
    export_downloads: downloads.ExportDownloads, //下载
    /**桥梁决策*/
    bridgeMaintenanceDecision: {

        getbridgempms: apiUrl + '/bridgempm/getbridgempms', //桥梁养护规划管理条件查询
        createbridgempmnew: apiUrl + '/bridgempm/createbridgempmnew', //新增桥梁养护规划管理
        operationbridgemp: apiUrl + '/bridgempm/operationbridgemp', //桥梁类型定制
        getbridgemps: apiUrl + '/bridgempm/getbridgemps', //桥梁类型定制查询
        operationbridgemps: apiUrl + "/bridgempm/operationbridgemps", //桥梁类型定制子表
        operationbridgemfp: apiUrl + '/bridgempm/operationbridgemfp', //资金规划操作
        getpmdbridgemfps: apiUrl + '/bridgempm/getpmdbridgemfps', //资金规划查询
        getweightcoefficients: apiUrl + "/ploselection/getweightcoefficients", //权重系数表
        operationweightcoefficient: apiUrl + '/ploselection/operationweightcoefficient', //权重系数操作
        operationmlspecification: apiUrl + '/ploselection/operationmlspecification', //养护对象规划对应表
        getspecifications: apiUrl + '/ploselection/getspecifications', //养护对象规划对应表查询
        getplanningobject: apiUrl + '/ploselection/getplanningobject', //对象选择
        operationploselection: apiUrl + '/ploselection/operationploselection', //向量组操作
        getploselections: apiUrl + '/ploselection/getploselections', //向量组查询
        getploselection: apiUrl + '/ploselection/getploselection', //向量组单列
        classifiedcounting: apiUrl + '/ploselection/classifiedcounting', //分类计算
        predictioncalculation: apiUrl + '/ploselection/predictioncalculation', //预测结果
        operationpredictoutcome: apiUrl + '/ploselection/operationpredictoutcome', //保存预测结果
        curingtime: apiUrl + '/ploselection/curingtime', //计算养护时机
        diseaseforecast: apiUrl + '/ploselection/diseaseforecast', //决策优化
        operationoptimizedresult: apiUrl + '/ploselection/operationoptimizedresult', //决策优化保存
        saveoptimizedresults: apiUrl + '/ploselection/saveoptimizedresults', //资金优化保存
        operationeffecttest: apiUrl + '/ploselection/operationeffecttest', //校验结果保存
        probabilitycalculation: apiUrl + '/ploselection/probabilitycalculation', //概率计算
        diseasestatistics: apiUrl + '/ploselection/diseasestatistics', //病害统计
        gettunnelmpms: apiUrl + '/tunnelmpm/gettunnelmpms', //隧道养护规划管理条件查询
        createtunnelmpmnew: apiUrl + '/tunnelmpm/createtunnelmpmnew', // 新增隧道养护规划管理
        gettunnelmps: apiUrl + '/tunnelmpm/gettunnelmps', //隧道养护规划条件查询
        operationtunnelmp: apiUrl + '/tunnelmpm/operationtunnelmp', //隧道养护规划
        operationtunnelmps: apiUrl + '/tunnelmpm/operationtunnelmps', //操作隧道养护规划子表
        getpmdtunnelmfps: apiUrl + '/tunnelmpm/getpmdtunnelmfps', //隧道养护规划资金规划条件查询
        operationtunnelmfp: apiUrl + '/tunnelmpm/operationtunnelmfp', //隧道新增养护资金规划
    },
    /**路面决策*/
    routeDecision: {
        operationpavementplan: apiUrl + '/pavementmdpm/operationpavementplan', //路面养护规划管理
        getpmdpavementplanmanagementlist: apiUrl + '/pavementmdpm/getpmdpavementplanmanagementlist', //获取路面养护规划
        existstestdata: apiUrl + "/pavementmdpm/existstestdata", //路面养护决策管理路线相关数据验证

        operationsectionsdivided: apiUrl + '/pavementmdpm/operationsectionsdivided', //养护路段划分
        getpmdsectionsdivideds: apiUrl + '/pavementmdpm/getpmdsectionsdivideds', //养护路段划分条件查询
        getsectionsdivideds: apiUrl + '/pavementmdpm/getsectionsdivideds', // 养护路段划分子表条件查询

        getperventivemaintains: apiUrl + "/pavementmdpm/getperventivemaintains", //预防性养护条件查询
        getpmdperventivemaintain: apiUrl + "/pavementmdpm/getpmdperventivemaintain", //预防性养护单例查询
        operationperventivemaintain: apiUrl + "/pavementmdpm/operationperventivemaintain", //预防性养护规划
        saveperventivemaintain: apiUrl + '/pavementmdpm/saveperventivemaintain', //预防性养护保存

        getpitchmeasures: apiUrl + "/pavementmdpm/getpitchmeasures", //沥青路面预防性养护初选库条件查询
        operationpitchmeasure: apiUrl + "/pavementmdpm/operationpitchmeasure", //沥青路面预防性养护初选措施库操作
        operationcementmeasure: apiUrl + "/pavementmdpm/operationcementmeasure", //水泥路面预防性养护初选措施库操作
        getcementmeasures: apiUrl + "/pavementmdpm/getcementmeasures", //水泥路面预防性养护初选库条件查询
        operationsandmeasure: apiUrl + "/pavementmdpm/operationsandmeasure", //砂石路面预防性养护初选措施库操作
        getsandmeasures: apiUrl + "/pavementmdpm/getsandmeasures", //砂石路面预防性养护初选库条件查询
        getpmmeasurefs: apiUrl + "/pavementmdpm/getpmmeasurefs", //预防性养护措施的使用寿命与单位费用范围条件查询
        operationmeasuref: apiUrl + "/pavementmdpm/operationmeasuref", //预防性养护措施的使用寿命与单位费用范围条件操作
        getpmifws: apiUrl + "/pavementmdpm/getpmifws", //不同等级公路的影响因素权重系数Wi条件查询
        operationpmifw: apiUrl + "/pavementmdpm/operationpmifw", //不同等级公路的影响因素权重系数Wi操作
        getattributescores: apiUrl + "/pavementmdpm/getattributescores", //各常用预防性养护措施的属性分值范围Cij条件查询
        operationattributescore: apiUrl + "/pavementmdpm/operationattributescore", //各常用预防性养护措施的属性分值范围Cij操作

        getpmdrepairs: apiUrl + "/pavementmdpm/getpmdrepairs", //中修养护材料选择表条件查询
        operationrepairmaterials: apiUrl + "/pavementmdpm/operationrepairmaterials", //中修养护材料选择表操作
        operationrepairthickness: apiUrl + "/pavementmdpm/operationrepairthickness", //操作中修厚度表
        getrepairthicknesses: apiUrl + "/pavementmdpm/getrepairthicknesses", //中修养护材料选择表条件查询
        operationrepairmaintenance: apiUrl + "/pavementmdpm/operationrepairmaintenance", //中修养护计算
        getrepairmaintenances: apiUrl + "/pavementmdpm/getrepairmaintenances", //中修养护条件查询
        getpredictionrules: apiUrl + "/pavementmdpm/getpredictionrules", //养护类型预测规律表条件查询
        operationpredictionrule: apiUrl + "/pavementmdpm/operationpredictionrule", //养护类型预测规律表操作
        getoverhaulmaterials: apiUrl + "/pavementmdpm/getoverhaulmaterials", //大修养护材料选择表条件查询
        operationoverhaulmaterial: apiUrl + "/pavementmdpm/operationoverhaulmaterial", //大修养护材料选择表操作
        operationoverhaultype: apiUrl + "/pavementmdpm/operationoverhaultype", //大修类型判断表操作
        getoverhaultypes: apiUrl + "/pavementmdpm/getoverhaultypes", //大修类型判断表条件查询
        operationoverhaulmaintenance: apiUrl + "/pavementmdpm/operationoverhaulmaintenance", //大修养护计算
        getoverhaulmaintenances: apiUrl + "/pavementmdpm/getoverhaulmaintenances", //大修养护条件查询
        getpmddbls: apiUrl + "/pavementmdpm/getpmddbls", //断板率条件查询
        operationpmddbl: apiUrl + "/pavementmdpm/operationpmddbl", //断板率计算
        getmaintenanceplans: apiUrl + "/pavementmdpm/getmaintenanceplans", //养护方案条件查询
        getperiodindexstatistics: apiUrl + "/pavementmdpm/getperiodindexstatistics", //规划期指标统计条件查询
        operationdailymaintenance: apiUrl + "/pavementmdpm/operationdailymaintenance", //日常养护计算
        getdailymaintenances: apiUrl + "/pavementmdpm/getdailymaintenances", //日常养护条件查询

        getmacroplannings: apiUrl + "/pavementmdpm/getmacroplannings", //宏观规划决策
        operationmacroplanning: apiUrl + "/pavementmdpm/operationmacroplanning", //操作宏观规划决策

        getinfluencefactors: apiUrl + "/pavementmdpm/getinfluencefactors", //宏观决策影响因素分值表条件查询
        operationinfluencefactor: apiUrl + "/pavementmdpm/operationinfluencefactor", //操作宏观决策影响因素分值表
        
        getpmdmanagementlist: apiUrl + "/pavementmdpm/getpmdmanagementlist", //决策汇总
    },
    //涵洞决策
    culvertDecision: {
        getculvertmpms: apiUrl + '/culvertmpm/getculvertmpms', //涵洞规划管理条件查询
        operationsideculvertmpm: apiUrl + '/culvertmpm/operationsideculvertmpm', //操作涵洞规划管理
        getculvertmps: apiUrl + '/culvertmpm/getculvertmps', //涵洞规划条件查询
        operationsideculvertmp: apiUrl + '/culvertmpm/operationsideculvertmp', //操作涵洞规划
        getculvertmfps: apiUrl + '/culvertmpm/getculvertmfps', //涵洞资金规划条件查询
        operationsideculvertmfp: apiUrl + '/culvertmpm/operationsideculvertmfp', //操作涵洞资金规划
    },
    //防护设施决策
    sideSlopeDecision: {
        getsideslopempms: apiUrl + '/sideslopempm/getsideslopempms', //防护设施规划管理条件查询
        operationsideslopempm: apiUrl + '/sideslopempm/operationsideslopempm', //操作防护设施规划管理
        getsideslopemfps: apiUrl + '/sideslopempm/getsideslopemfps', //防护设施资金规划条件查询
        operationsideslopemfp: apiUrl + '/sideslopempm/operationsideslopemfp', //操作防护设施资金规划
        getsideslopemps: apiUrl + '/sideslopempm/getsideslopemps', //防护设施规划条件查询
        operationsideslopemp: apiUrl + '/sideslopempm/operationsideslopemp' //操作防护设施规划
    },
    analysis: {
        gettopdataasync: apiUrl + "/analysis/gettopdataasync", //首页顶部卡片数据获取
        getdiseasedata: apiUrl + "/analysis/getdiseasedata", //首页病害登记数据
        geemergencyreportdata: apiUrl + "/analysis/geemergencyreportdata", //首页应急事件报送信息
        getregisterdata: apiUrl + "/analysis/getregisterdata", //本周活跃用户数据获取
    },
    //桥梁评价子系统
    bridgeEvaluationSubsystem: {
        postbridgedevelopmenttrend: apiUrl + "/trafficassess/getbridgedevelopmenttrend", //桥梁病害发展趋势数据获取
        postbridgetrafficassesselist: apiUrl + "/trafficassess/getbridgetrafficassesselist", //桥梁评价汇总数据
        posttechnicalstatuswarninglist: apiUrl + "/trafficassess/gettechnicalstatuswarninglist", //桥梁技术状况预警
        postbridgequality: apiUrl + "/trafficassess/getbridgequality", //桥梁养护质量数据获取
    },
    //隧道评价子系统
    tunnelEvaluationSubsystem:  {
        posttunneltrafficassesselist: apiUrl + "/trafficassess/gettunneltrafficassesselist", //隧道评价汇总数据获取
        posttunnelwarninglist: apiUrl + "/trafficassess/gettechnicalstatuswarninglist", //隧道技术状况预警数据
        posttunnelquality: apiUrl + "/trafficassess/gettunnelquality", //隧道养护质量
        posttunneldevelopmenttrend: apiUrl + "/trafficassess/gettunneldevelopmenttrend", //隧道病害发展趋势数据获取
    },
    //边坡评价子系统
    slopeEvaluationSubsystem: {
        postsideslopetrafficassesselist: apiUrl + "/trafficassess/getsideslopetrafficassesselist", //边坡评价汇总数据获取
        postsideslopewarninglist: apiUrl + "/trafficassess/gettechnicalstatuswarninglist", //边坡技术状况预警数据
        postsideslopequality: apiUrl + "/trafficassess/getsideslopequality", //边坡养护质量
        postsideslopedevelopmenttrend: apiUrl + "/trafficassess/getsideslopedevelopmenttrend", //边坡病害发展趋势数据获取
    },
    //养护效果分析子系统
    maintenanceEffectAnalysisSubsystem: {
        getanalysiswarninglist: apiUrl + "/trafficassess/getanalysiswarninglist", //养护效果分析预警获取
        getanalysisquality: apiUrl + "/trafficassess/getanalysisquality", //养护效果分析养护质量数据
        postmaintaineffectanalysis: apiUrl + "/trafficassess/getmaintaineffectanalysis", //养护效果分析
        postmaintaineffectevaluate: apiUrl + "/trafficassess/getmaintaineffectevaluate", //养护效果评定
        postmaintaineffectanalysis: apiUrl + "/trafficassess/getmaintaineffectanalysis", //养护效果评价汇总
        getanalysiswarningsublist: apiUrl + "/trafficassess/getanalysiswarningsublist", //养护效果分析预警明细
    },
    // 涵洞评价子系统
    culvertEvaluationSubsystem: {
        postculverttrafficassesselist: apiUrl + "/trafficassess/getculverttrafficassesselist", //涵洞评价汇总获取
        postculvertwarninglist: apiUrl + "/trafficassess/gettechnicalstatuswarninglist", //涵洞技术状况预警数据
        postculvertquality: apiUrl + "/trafficassess/getculvertquality", //涵洞养护质量
        postculvertdevelopmenttrend: apiUrl + "/trafficassess/getculvertdevelopmenttrend", //涵洞病害发展趋势
    },
	//决策报告导出/导入
	assessExport:{
		exportRoadDecisionReport:apiUrl + "/assessimport/exportroute",//导出路面决策报告
		exportBridgeDecisionReport:apiUrl + "/assessimport/exportbridge",//导出桥梁决策报告
		exportTunnelDecisionReport:apiUrl + "/assessimport/exporttunnel",//导出隧道决策报告

		nationalassess:apiUrl + "/assessimport/nationalassess",//导出隧道决策报告
		importrutting:apiUrl + "/assessimport/importrutting",//沥青破损导入
		importsurfaceevenness:apiUrl + "/assessimport/importsurfaceevenness",//车辙导入
		importsurfaceevenness:apiUrl + "/assessimport/importsurfaceevenness",//平整度导入
		importantiskating:apiUrl + "/assessimport/importantiskating",//抗滑导入
		importtrip:apiUrl + "/assessimport/importtrip",//跳车导入
	},
}

/**
 *
 * @returns {{user_login: string}}
 */
export { url }